// global state for menu hover tracking
var isMenuActive = false;

// idle header white after 1 min (same look as hover)
document.addEventListener("DOMContentLoaded", function () {
  var IDLE_MS = 5000;
  var timer = null;
  var isIdle = false;

  function hoverBgs() {
    return document.querySelectorAll(".header-hover-bg");
  }

  function isOverlayOpen() {
    var miniCart = document.querySelector("[data-mini-cart]");
    var searchModal = document.querySelector("[data-search-modal]");
    var mobileMenu = document.querySelector("[data-mobile-menu-content]");
    var isCartOpen = miniCart && !miniCart.classList.contains("opacity-0");
    var isSearchOpen =
      searchModal && !searchModal.classList.contains("opacity-0");
    var menuHeight = mobileMenu && mobileMenu.style.height;
    var isMobileMenuOpen =
      !!menuHeight && menuHeight !== "0" && menuHeight !== "0px";
    return isCartOpen || isSearchOpen || isMobileMenuOpen || isMenuActive;
  }

  function setIdleWhite(on) {
    isIdle = on;
    hoverBgs().forEach(function (el) {
      if (on) el.classList.add("is-idle-white");
      else el.classList.remove("is-idle-white");
    });
  }

  function onActivity() {
    if (isIdle) setIdleWhite(false);
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (!isOverlayOpen()) setIdleWhite(true);
    }, IDLE_MS);
  }

  [
    "mousemove",
    "mousedown",
    "keydown",
    "scroll",
    "touchstart",
    "wheel",
  ].forEach(function (evt) {
    window.addEventListener(evt, onActivity, { passive: true });
  });

  onActivity();

  // white header on scroll up (same look as hover)
  var lastScrollY = window.scrollY || 0;
  var scrollWhite = false;

  function setScrollWhite(on) {
    if (scrollWhite === on) return;
    scrollWhite = on;
    hoverBgs().forEach(function (el) {
      if (on) el.classList.add("is-scroll-white");
      else el.classList.remove("is-scroll-white");
    });
  }

  window.addEventListener(
    "scroll",
    function () {
      var currentY = window.scrollY || document.documentElement.scrollTop || 0;
      if (isOverlayOpen()) {
        lastScrollY = currentY;
        return;
      }

      if (currentY <= 8) {
        setScrollWhite(false);
      } else if (currentY < lastScrollY) {
        setScrollWhite(true);
      } else if (currentY > lastScrollY) {
        setScrollWhite(false);
      }

      lastScrollY = currentY;
    },
    { passive: true },
  );
});

// main header
document.addEventListener("DOMContentLoaded", function () {
  var header = document.querySelector("header");
  var menuWrapper = document.querySelector(".menu-wrapper");
  var menuTriggers = document.querySelectorAll("[data-menu]");
  var menuContents = document.querySelectorAll("[data-menu-content]");
  if (!menuWrapper) return;
  menuTriggers.forEach(function (trigger) {
    trigger.addEventListener("mouseenter", function () {
      isMenuActive = true;

      // Close search modal if it's open
      var searchModal = document.querySelector("[data-search-modal]");
      var searchTrigger = document.querySelector("[data-search]");
      var mobileHeader = document.querySelector("[data-mobile-header]");
      if (searchModal && !searchModal.classList.contains("opacity-0")) {
        searchModal.classList.add("opacity-0", "pointer-events-none");
        searchModal.classList.remove("opacity-100", "pointer-events-auto");
        if (searchTrigger) searchTrigger.classList.remove("uppercase");
        if (mobileHeader) mobileHeader.classList.remove("bg-white");
        document.body.style.overflow = "";

        // Reset search input and show only first 4 products
        var searchInput = searchModal.querySelector('input[name="q"]');
        if (searchInput) {
          searchInput.value = "";
        }
        var productItems = searchModal.querySelectorAll(".search-product-item");
        productItems.forEach(function (item, index) {
          if (index < 4) {
            item.classList.remove("hidden");
          } else {
            item.classList.add("hidden");
          }
        });
      }

      // close mini cart if it's open
      var miniCart = document.querySelector("[data-mini-cart]");
      var miniCartOverlay = document.querySelector("[data-mini-cart-overlay]");
      var cartTrigger = document.querySelector("[data-cart]");
      if (miniCart && !miniCart.classList.contains("opacity-0")) {
        miniCart.classList.add("opacity-0", "pointer-events-none");
        miniCart.classList.remove("opacity-100", "pointer-events-auto");
        if (miniCartOverlay) {
          miniCartOverlay.classList.add(
            "opacity-0",
            "pointer-events-none",
            "hidden",
          );
          miniCartOverlay.classList.remove(
            "opacity-100",
            "pointer-events-auto",
          );
        }
        if (cartTrigger) cartTrigger.classList.remove("uppercase");
        document.body.style.overflow = "";
      }

      if (header) header.classList.add("backdrop-grayscale", "bg-black/10");
      menuWrapper.classList.add("bg-white", "min-h-[234px]");
      menuTriggers.forEach(function (menuElt) {
        menuElt.classList.add("uppercase");
      });
      menuContents.forEach(function (content) {
        content.classList.remove("opacity-0");
        content.classList.remove("h-0");
      });
    });
  });
  menuWrapper.addEventListener("mouseleave", function (e) {
    var relatedTarget = e.relatedTarget;
    if (
      relatedTarget &&
      (menuWrapper === relatedTarget || menuWrapper.contains(relatedTarget))
    ) {
      return;
    }
    isMenuActive = false;

    // Only remove header styles if mini cart or search modal is not open
    var miniCart = document.querySelector("[data-mini-cart]");
    var searchModal = document.querySelector("[data-search-modal]");
    var isCartOpen = miniCart && !miniCart.classList.contains("opacity-0");
    var isSearchOpen =
      searchModal && !searchModal.classList.contains("opacity-0");

    if (!isCartOpen && !isSearchOpen) {
      if (header) header.classList.remove("backdrop-grayscale", "bg-black/10");
      menuWrapper.classList.remove("bg-white", "min-h-[234px]");
    }

    menuTriggers.forEach(function (menuElt) {
      menuElt.classList.remove("uppercase");
    });
    menuContents.forEach(function (content) {
      content.classList.add("opacity-0");
      content.classList.add("h-0");
    });
  });
});

// header menu images
(function () {
  var menuContainer = document.querySelector("[data-menu-content]");
  if (!menuContainer) return;
  var menuLinks = menuContainer.querySelectorAll("[data-menu-link]");
  var menuImages = document.querySelectorAll(".menu-hover-image");

  function clearImages() {
    menuImages.forEach(function (img) {
      img.classList.remove("opacity-100");
      img.classList.add("opacity-0");
    });
  }

  menuLinks.forEach(function (link) {
    link.addEventListener("mouseenter", function () {
      var idx = link.getAttribute("data-index");
      clearImages();
      var img = document.querySelector(
        '.menu-hover-image[data-index="' + idx + '"]',
      );
      if (img) {
        img.classList.remove("opacity-0");
        img.classList.add("opacity-100");
      }
    });
    link.addEventListener("mouseleave", function () {
      clearImages();
    });
  });

  if (menuContainer) {
    menuContainer.addEventListener("mouseleave", clearImages);
  }
})();

// subnav - unified desktop/mobile
(function () {
  var subnavContainers = document.querySelectorAll("[data-subnav-container]");
  if (!subnavContainers.length) return;

  subnavContainers.forEach(function (container) {
    var items = container.querySelectorAll("[data-subnav-item]");
    var images = container.querySelectorAll(".subnav-image");

    function clearImages() {
      images.forEach(function (img) {
        img.classList.remove("opacity-100");
        img.classList.add("opacity-0");
      });
    }

    // Desktop hover behavior - only on larger screens
    function handleItemInteraction(item) {
      // Check if we're on desktop (md breakpoint and up)
      if (window.innerWidth >= 768) {
        var idx = item.getAttribute("data-index");
        clearImages();
        var img = container.querySelector(
          '.subnav-image[data-index="' + idx + '"]',
        );
        if (img) {
          img.classList.remove("opacity-0");
          img.classList.add("opacity-100");
        }
      }
    }

    items.forEach(function (item) {
      // Find the link/span element that wraps the title (not the title itself)
      var linkElement = item.querySelector("a.w-fit, span.w-fit");

      if (linkElement) {
        // Mouse events for desktop hover - only on the link element
        linkElement.addEventListener("mouseenter", function () {
          handleItemInteraction(item);
        });
        linkElement.addEventListener("mouseleave", function () {
          if (window.innerWidth >= 768) {
            clearImages();
          }
        });

        // Focus events for accessibility on the title span
        var titleElement = linkElement.querySelector(".subnav-title");
        if (titleElement) {
          titleElement.addEventListener("focus", function () {
            handleItemInteraction(item);
          });
          titleElement.addEventListener("blur", function () {
            if (window.innerWidth >= 768) {
              clearImages();
            }
          });
        }
      }
    });
  });
})();

// newsletter forms
document.addEventListener("DOMContentLoaded", function () {
  var forms = document.querySelectorAll('[id*="newsletter"]');
  forms.forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]');
      var button = form.querySelector("button");
      var formData = new FormData(form);
      button.disabled = true;
      fetch(form.action, {
        method: "POST",
        body: formData,
      })
        .then(function (response) {
          if (response.ok || response.redirected) {
            email.value = "";
            email.placeholder = "Thank you for joining";
          } else {
            email.placeholder = "Please try again";
          }
          button.disabled = false;
          setTimeout(function () {
            email.placeholder = "Email";
          }, 3e3);
        })
        .catch(function () {
          email.placeholder = "Please try again";
          button.disabled = false;
          setTimeout(function () {
            email.placeholder = "Email";
          }, 3e3);
        });
    });
  });
});

// book visit btn
document.addEventListener("DOMContentLoaded", function () {
  var bookVisitButton = document.getElementById("book-visit-button");
  if (!bookVisitButton) return;
  function handleScroll() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 100) {
      bookVisitButton.classList.remove("opacity-0", "pointer-events-none");
      bookVisitButton.classList.add("opacity-100", "pointer-events-auto");
    } else {
      bookVisitButton.classList.remove("opacity-100", "pointer-events-auto");
      bookVisitButton.classList.add("opacity-0", "pointer-events-none");
    }
  }
  window.addEventListener("scroll", handleScroll);
  handleScroll();
});

// mobile product form container fixed toggle
document.addEventListener("DOMContentLoaded", function () {
  var productFormMobile = document.querySelector(
    ".product-form-container-mobile",
  );
  if (!productFormMobile) return;

  // store original bottom position in document flow
  var originalBottom = null;
  var isInitialized = false;

  // helper to get reliable scroll position for Safari
  function getScrollTop() {
    // Safari prefers document.documentElement.scrollTop, especially on mobile
    return (
      window.scrollY ||
      document.documentElement.scrollTop ||
      window.pageYOffset ||
      0
    );
  }

  function updateOriginalBottom() {
    var wasFixed = productFormMobile.classList.contains("fixed");
    if (wasFixed) {
      productFormMobile.classList.remove("fixed", "p-4");
      // force reflow to get accurate position
      void productFormMobile.offsetHeight;
    }

    var scrollTop = getScrollTop();
    var containerRect = productFormMobile.getBoundingClientRect();
    originalBottom = scrollTop + containerRect.bottom + 16;

    if (wasFixed) {
      productFormMobile.classList.add("fixed", "p-4");
    }
  }

  function handleProductFormScroll() {
    if (originalBottom === null) {
      updateOriginalBottom();
      return;
    }

    // don't apply fixed on initial load if we haven't scrolled yet
    if (!isInitialized) {
      var currentScroll = getScrollTop();
      if (currentScroll === 0 || currentScroll <= 1) {
        productFormMobile.classList.remove("fixed", "p-4");
        return;
      }
      isInitialized = true;
    }

    var scrollTop = getScrollTop();
    var windowHeight = window.innerHeight;
    var viewportBottom = scrollTop + windowHeight;

    // check if bottom of viewport has reached or passed the bottom of container
    if (viewportBottom >= originalBottom) {
      productFormMobile.classList.add("fixed", "p-4");
    } else {
      productFormMobile.classList.remove("fixed", "p-4");
    }

    // fade out logic: check if scrolled past ctl-pdp or pdp-cta
    var ctlPdp = document.querySelector(".ctl-pdp");
    var fadeOutElement = ctlPdp || document.querySelector(".pdp-cta");

    if (fadeOutElement) {
      var fadeOutRect = fadeOutElement.getBoundingClientRect();
      var fadeOutTop = scrollTop + fadeOutRect.top;

      // fade out when scrolled past the element's top
      if (scrollTop >= fadeOutTop) {
        productFormMobile.classList.add("opacity-0", "pointer-events-none");
        productFormMobile.classList.remove(
          "opacity-100",
          "pointer-events-auto",
        );
      } else {
        productFormMobile.classList.remove("opacity-0", "pointer-events-none");
        productFormMobile.classList.add("opacity-100", "pointer-events-auto");
      }
    }
  }

  // wait for page to be fully rendered before calculating positions (Safari fix)
  function initialize() {
    requestAnimationFrame(function () {
      updateOriginalBottom();
      // double-check after a short delay to ensure Safari has settled
      setTimeout(function () {
        updateOriginalBottom();
        handleProductFormScroll();
        window.addEventListener("scroll", handleProductFormScroll);
      }, 100);
    });
  }

  initialize();

  // recalculate original position on resize
  var resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      updateOriginalBottom();
      handleProductFormScroll();
    }, 100);
  });
});

// plp grid size (desktop 4/3/2, mobile 2/1)
document.addEventListener("DOMContentLoaded", function () {
  var desktopInputs = document.querySelectorAll('input[name="grid-size"]');
  var mobileInputs = document.querySelectorAll(
    'input[name="grid-size-mobile"]',
  );
  var plpGrid = document.querySelector(".plp-grid");
  if (!plpGrid || desktopInputs.length === 0) return;

  function getDesktopSize() {
    var active = document.querySelector('input[name="grid-size"]:checked');
    return active ? active.value : "3";
  }

  function getMobileSize() {
    var active = document.querySelector(
      'input[name="grid-size-mobile"]:checked',
    );
    return active ? active.value : "2";
  }

  function updateGridSize() {
    var desktopSize = getDesktopSize();
    var mobileSize = getMobileSize();
    var productCards = plpGrid.querySelectorAll(".plp-product-item");
    var editorials = plpGrid.querySelectorAll(".plp-editorial");
    var productSpanClasses = [
      "col-span-4",
      "col-span-6",
      "col-span-8",
      "col-span-12",
      "md:col-span-2",
      "md:col-span-3",
      "md:col-span-4",
      "md:col-span-6",
    ];

    // desktop density drives md spans + editorial set
    var desktopSpanBySize = {
      4: "md:col-span-2",
      3: "md:col-span-4",
      2: "md:col-span-6",
    };
    // mobile only offers 2-up or 1-up
    var mobileSpan =
      String(mobileSize) === "1"
        ? String(desktopSize) === "4"
          ? "col-span-8"
          : "col-span-12"
        : String(desktopSize) === "4"
          ? "col-span-4"
          : "col-span-6";

    var activeSpans = [
      mobileSpan,
      desktopSpanBySize[desktopSize] || desktopSpanBySize["3"],
    ];

    plpGrid.setAttribute("data-grid-size", String(desktopSize));
    plpGrid.setAttribute("data-grid-size-mobile", String(mobileSize));

    if (String(desktopSize) === "4") {
      plpGrid.classList.remove("grid-cols-12");
      plpGrid.classList.add("grid-cols-8");
    } else {
      plpGrid.classList.remove("grid-cols-8");
      plpGrid.classList.add("grid-cols-12");
    }

    productCards.forEach(function (card) {
      productSpanClasses.forEach(function (cls) {
        card.classList.remove(cls);
      });
      activeSpans.forEach(function (cls) {
        card.classList.add(cls);
      });
    });

    editorials.forEach(function (card) {
      if (card.getAttribute("data-editorial-for") === String(desktopSize)) {
        card.classList.remove("hidden");
      } else {
        card.classList.add("hidden");
      }
    });
  }

  function updateCheckboxVisuals(inputs) {
    inputs.forEach(function (input) {
      var label = input.closest("label");
      var labelText = label && label.querySelector("span");
      if (!labelText) return;
      if (input.checked) {
        labelText.classList.add("uppercase");
      } else {
        labelText.classList.remove("uppercase");
      }
    });
  }

  function bindExclusiveGroup(inputs, onChange) {
    inputs.forEach(function (input) {
      input.addEventListener("change", function () {
        inputs.forEach(function (otherInput) {
          if (otherInput !== input) otherInput.checked = false;
        });
        this.checked = true;
        updateCheckboxVisuals(inputs);

        plpGrid.style.transition = "opacity 200ms ease-out";
        plpGrid.style.opacity = "0";

        setTimeout(function () {
          onChange();
          setTimeout(function () {
            plpGrid.style.opacity = "1";
          }, 50);
        }, 200);
      });
    });
  }

  bindExclusiveGroup(desktopInputs, updateGridSize);
  bindExclusiveGroup(mobileInputs, updateGridSize);
  updateCheckboxVisuals(desktopInputs);
  updateCheckboxVisuals(mobileInputs);
  updateGridSize();

  // re-apply grid size after load more
  document.addEventListener("plp:appended", function () {
    updateGridSize();
  });
});

// pdp slider
document.addEventListener("DOMContentLoaded", function () {
  var pdpSliderEl = document.querySelector(".pdp-slider");
  if (!pdpSliderEl) return;

  // Initialize thumbnail slider first
  var pdpThumbsSlider = new Swiper(".pdp-thumbs-slider", {
    direction: "horizontal",
    slidesPerView: "auto",
    slideToClickedSlide: true,
    watchSlidesProgress: true,
  });

  // Initialize main slider with thumbs
  var pdpSwiper = new Swiper(pdpSliderEl, {
    // effect: "fade",
    // slidesPerView: 1,
    slidesPerView: 1,
    simulateTouch: true,
    loop: true,
    watchSlidesProgress: true,
    // fadeEffect: {
    //   crossFade: true,
    // },
    mousewheel: {
      forceToAxis: true,
      thresholdDelta: 20,
    },
    navigation: {
      nextEl: ".slider-next",
      prevEl: ".slider-prev",
    },
    thumbs: {
      swiper: pdpThumbsSlider,
    },
    breakpoints: {
      768: {
        simulateTouch: false,
        slidesPerView: "auto",
      },
    },
    on: {
      init: function (swiper) {
        syncPdpVideos(swiper);
      },
      slideChange: function (swiper) {
        syncPdpVideos(swiper);
      },
      progress: function (swiper) {
        syncPdpVideos(swiper);
      },
      loopFix: function (swiper) {
        syncPdpVideos(swiper);
      },
    },
  });

  // play videos only on visible slides
  function syncPdpVideos(swiper) {
    if (!swiper || !swiper.slides) return;
    swiper.slides.forEach(function (slide) {
      var video = slide.querySelector("video");
      if (!video) return;

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.playsInline = true;

      var isVisible =
        slide.classList.contains("swiper-slide-visible") ||
        slide.classList.contains("swiper-slide-active");

      if (isVisible) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      } else {
        video.pause();
      }
    });
  }
});

// product card sliders
document.addEventListener("DOMContentLoaded", function () {
  var productCardSliders = document.querySelectorAll(".product-card-slider");

  if (productCardSliders.length === 0) return;

  productCardSliders.forEach(function (sliderEl, index) {
    var wrapper = sliderEl.closest(".product-card-image-wrapper");
    var prevBtn = wrapper.querySelector(".product-card-slider-prev");
    var nextBtn = wrapper.querySelector(".product-card-slider-next");

    new Swiper(sliderEl, {
      effect: "fade",
      slidesPerView: 1,
      loop: true,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      // Prevent slider from interfering with product link
      allowTouchMove: false,
      simulateTouch: false,
    });

    // Prevent navigation clicks from following the product link
    if (prevBtn) {
      prevBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    }
  });
});

// product zoom modal
document.addEventListener("DOMContentLoaded", function () {
  var modal = document.getElementById("product-zoom-modal");
  if (!modal) return;

  var closeBtn = modal.querySelector(".zoom-modal-close");
  var modalContent = modal.querySelector(".zoom-modal-content");
  var zoomImages = modal.querySelectorAll(".zoom-modal-image");
  var zoomThumbs = modal.querySelectorAll(".zoom-thumb");
  // Don't include thumb slider
  var slides = document.querySelectorAll(
    ".pdp-slider > .swiper-wrapper > .swiper-slide",
  );

  // Open modal when clicking on any slide
  slides.forEach(function (slide) {
    slide.style.cursor = "zoom-in";
    slide.addEventListener("click", function () {
      modal.classList.remove("opacity-0", "pointer-events-none");
      modal.classList.add("opacity-100", "pointer-events-auto");
      document.body.style.overflow = "hidden";

      // add pointer-events-none to menu-wrapper and mobile header, opacity-0 to header
      var menuWrapper = document.querySelector(".menu-wrapper");
      var mobileHeader = document.querySelector("[data-mobile-header]");
      var header = document.querySelector("header");
      if (menuWrapper) {
        menuWrapper.classList.remove("pointer-events-auto");
        menuWrapper.classList.add("pointer-events-none");
      }
      if (mobileHeader) {
        mobileHeader.classList.remove("pointer-events-auto");
        mobileHeader.classList.add("pointer-events-none");
      }
      if (header) {
        header.classList.add("opacity-0");
      }

      // add classes to product cta
      var pdpCta = document.querySelector(".pdp-cta");
      if (pdpCta && window.innerWidth >= 1024) {
        pdpCta.classList.add("fixed", "w-[calc(25%-0.75rem)]", "right-0");
      }

      // Set first thumbnail as active on open
      zoomThumbs.forEach(function (thumb, index) {
        if (index === 0) {
          thumb.classList.remove("opacity-30");
          thumb.classList.add("opacity-100");
        } else {
          thumb.classList.remove("opacity-100");
          thumb.classList.add("opacity-30");
        }
      });
    });
  });

  // Close modal
  function closeModal() {
    modal.classList.remove("opacity-100", "pointer-events-auto");
    modal.classList.add("opacity-0", "pointer-events-none");
    document.body.style.overflow = "";

    // remove pointer-events-none from menu-wrapper and mobile header, opacity-0 from header
    var menuWrapper = document.querySelector(".menu-wrapper");
    var mobileHeader = document.querySelector("[data-mobile-header]");
    var header = document.querySelector("header");
    if (menuWrapper) {
      menuWrapper.classList.remove("pointer-events-none");
      menuWrapper.classList.add("pointer-events-auto");
    }
    if (mobileHeader) {
      mobileHeader.classList.remove("pointer-events-none");
      mobileHeader.classList.add("pointer-events-auto");
    }
    if (header) {
      header.classList.remove("opacity-0");
    }

    // remove classes from product cta
    var pdpCta = document.querySelector(".pdp-cta");
    if (pdpCta) {
      pdpCta.classList.remove("fixed", "w-[calc(25%-0.75rem)]", "right-0");
    }
  }

  closeBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    closeModal();
  });

  // close on clicking anywhere in the modal content
  modalContent.addEventListener("click", closeModal);

  // Close on clicking the backdrop
  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Close on ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("opacity-100")) {
      closeModal();
    }
  });

  // Handle thumbnail clicks to scroll to image
  zoomThumbs.forEach(function (thumb) {
    thumb.addEventListener("click", function (e) {
      e.stopPropagation();
      var thumbIndex = parseInt(this.getAttribute("data-thumb-index"));
      var targetImage = zoomImages[thumbIndex];

      if (targetImage) {
        targetImage.scrollIntoView({ behavior: "smooth", block: "start" });
      }

      // Update thumbnail active state
      zoomThumbs.forEach(function (t) {
        t.classList.remove("opacity-100");
        t.classList.add("opacity-30");
      });
      this.classList.remove("opacity-30");
      this.classList.add("opacity-100");
    });
  });

  // Update active thumbnail on scroll
  var updateActiveThumb = function () {
    var scrollTop = modalContent.scrollTop;
    var activeIndex = 0;

    zoomImages.forEach(function (img, index) {
      var imgTop = img.offsetTop - modalContent.offsetTop;
      if (scrollTop >= imgTop - 100) {
        activeIndex = index;
      }
    });

    zoomThumbs.forEach(function (thumb, index) {
      if (index === activeIndex) {
        thumb.classList.remove("opacity-30");
        thumb.classList.add("opacity-100");
      } else {
        thumb.classList.remove("opacity-100");
        thumb.classList.add("opacity-30");
      }
    });
  };

  modalContent.addEventListener("scroll", updateActiveThumb);
});

// search modal toggle
document.addEventListener("DOMContentLoaded", function () {
  var searchTrigger = document.querySelector("[data-search]");
  var searchModal = document.querySelector("[data-search-modal]");
  var header = document.querySelector("header");
  var menuWrapper = document.querySelector(".menu-wrapper");
  var mobileHeader = document.querySelector("[data-mobile-header]");
  if (!searchTrigger || !searchModal) return;

  function toggleSearchModal() {
    var isOpen = !searchModal.classList.contains("opacity-0");

    if (isOpen) {
      // Close search
      searchModal.classList.add("opacity-0", "pointer-events-none");
      searchModal.classList.remove("opacity-100", "pointer-events-auto");
      searchTrigger.classList.remove("uppercase");
      if (header) header.classList.remove("backdrop-grayscale", "bg-black/10");
      if (menuWrapper)
        menuWrapper.classList.remove("bg-white", "min-h-[234px]");
      if (mobileHeader) mobileHeader.classList.remove("bg-white");
      document.body.style.overflow = "";

      // Reset search input and show only first 4 products
      var searchInput = searchModal.querySelector('input[name="q"]');
      if (searchInput) {
        searchInput.value = "";
      }
      var productItems = searchModal.querySelectorAll(".search-product-item");
      productItems.forEach(function (item, index) {
        if (index < 4) {
          item.classList.remove("hidden");
        } else {
          item.classList.add("hidden");
        }
      });
    } else {
      // close mini cart if it's open
      var miniCart = document.querySelector("[data-mini-cart]");
      var miniCartOverlay = document.querySelector("[data-mini-cart-overlay]");
      var cartTrigger = document.querySelector("[data-cart]");
      if (miniCart && !miniCart.classList.contains("opacity-0")) {
        miniCart.classList.add("opacity-0", "pointer-events-none");
        miniCart.classList.remove("opacity-100", "pointer-events-auto");
        if (miniCartOverlay) {
          miniCartOverlay.classList.add(
            "opacity-0",
            "pointer-events-none",
            "hidden",
          );
          miniCartOverlay.classList.remove(
            "opacity-100",
            "pointer-events-auto",
          );
        }
        if (cartTrigger) cartTrigger.classList.remove("uppercase");
      }

      // close menu if it's open
      var menuTriggers = document.querySelectorAll("[data-menu]");
      var menuContents = document.querySelectorAll("[data-menu-content]");
      menuTriggers.forEach(function (menuElt) {
        menuElt.classList.remove("uppercase");
      });
      menuContents.forEach(function (content) {
        content.classList.add("opacity-0");
        content.classList.add("h-0");
      });

      // Open search
      searchModal.classList.remove("opacity-0", "pointer-events-none");
      searchModal.classList.add("opacity-100", "pointer-events-auto");
      searchTrigger.classList.add("uppercase");
      if (header) header.classList.add("backdrop-grayscale", "bg-black/10");
      if (menuWrapper) {
        menuWrapper.classList.remove("min-h-[234px]");
        menuWrapper.classList.add("bg-white", "min-h-[234px]");
      }
      if (mobileHeader) mobileHeader.classList.add("bg-white");
      document.body.style.overflow = "hidden";

      // Focus on search input
      var searchInput = searchModal.querySelector('input[type="text"]');
      if (searchInput) {
        setTimeout(function () {
          searchInput.focus();
        }, 100);
      }
    }
  }

  // Toggle on search button click
  searchTrigger.addEventListener("click", function (e) {
    e.stopPropagation();
    toggleSearchModal();
  });

  // Client-side product search/filter
  var searchInput = searchModal.querySelector('input[name="q"]');
  var productItems = searchModal.querySelectorAll(".search-product-item");
  var noResultsMessage = searchModal.querySelector("[data-no-results]");

  if (searchInput && productItems.length > 0) {
    searchInput.addEventListener("input", function (e) {
      var searchTerm = e.target.value.toLowerCase().trim();
      var visibleCount = 0;
      var maxResults = 4;

      productItems.forEach(function (item, index) {
        if (searchTerm === "") {
          // No search term: show only first 4 products
          if (index < 4) {
            item.classList.remove("hidden");
          } else {
            item.classList.add("hidden");
          }
        } else {
          // Search term exists: filter products (max 4 results)
          var title = item.getAttribute("data-product-title") || "";
          var type = item.getAttribute("data-product-type") || "";
          var tags = item.getAttribute("data-product-tags") || "";

          var matches =
            title.includes(searchTerm) ||
            type.includes(searchTerm) ||
            tags.includes(searchTerm);

          if (matches && visibleCount < maxResults) {
            item.classList.remove("hidden");
            visibleCount++;
          } else {
            item.classList.add("hidden");
          }
        }
      });

      // Show/hide no results message
      if (noResultsMessage) {
        if (searchTerm !== "" && visibleCount === 0) {
          noResultsMessage.classList.remove("hidden");
        } else {
          noResultsMessage.classList.add("hidden");
        }
      }
    });
  }

  // Close on clicking outside the search modal
  document.addEventListener("click", function (e) {
    var isSearchOpen = !searchModal.classList.contains("opacity-0");

    if (!isSearchOpen) return;

    if (!searchModal.contains(e.target) && !searchTrigger.contains(e.target)) {
      toggleSearchModal();
    }
  });

  // Close on ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !searchModal.classList.contains("opacity-0")) {
      toggleSearchModal();
    }
  });
});

// mini cart toggle
document.addEventListener("DOMContentLoaded", function () {
  var cartTrigger = document.querySelector("[data-cart]");
  var miniCart = document.querySelector("[data-mini-cart]");
  var miniCartOverlay = document.querySelector("[data-mini-cart-overlay]");
  var header = document.querySelector("header");
  var menuWrapper = document.querySelector(".menu-wrapper");
  if (!cartTrigger || !miniCart) return;

  function updateHeaderStyles() {
    var isOpen = !miniCart.classList.contains("opacity-0");
    // check if search modal is open
    var searchModal = document.querySelector("[data-search-modal]");
    var isSearchOpen =
      searchModal && !searchModal.classList.contains("opacity-0");

    if (isOpen) {
      // cart is open - apply header styles and show overlay
      if (miniCartOverlay) {
        miniCartOverlay.classList.remove(
          "opacity-0",
          "pointer-events-none",
          "hidden",
        );
        miniCartOverlay.classList.add("opacity-100", "pointer-events-auto");
      }
      if (menuWrapper) menuWrapper.classList.add("bg-white");
    } else {
      // cart is closed - remove header styles and hide overlay
      if (miniCartOverlay) {
        miniCartOverlay.classList.add(
          "opacity-0",
          "pointer-events-none",
          "hidden",
        );
        miniCartOverlay.classList.remove("opacity-100", "pointer-events-auto");
      }
      if (menuWrapper) menuWrapper.classList.remove("bg-white");

      // only remove header grayscale if menu is not active and search is not open
      if (!isMenuActive && !isSearchOpen) {
        if (header)
          header.classList.remove("backdrop-grayscale", "bg-black/10");
      }
    }
  }

  function toggleMiniCart() {
    var isOpen = !miniCart.classList.contains("opacity-0");

    if (isOpen) {
      // close cart
      miniCart.classList.add("opacity-0", "pointer-events-none");
      miniCart.classList.remove("opacity-100", "pointer-events-auto");
      cartTrigger.classList.remove("uppercase");
      document.body.style.overflow = "";
    } else {
      // Close search modal if it's open
      var searchModal = document.querySelector("[data-search-modal]");
      var searchTrigger = document.querySelector("[data-search]");
      var mobileHeader = document.querySelector("[data-mobile-header]");
      if (searchModal && !searchModal.classList.contains("opacity-0")) {
        searchModal.classList.add("opacity-0", "pointer-events-none");
        searchModal.classList.remove("opacity-100", "pointer-events-auto");
        if (searchTrigger) searchTrigger.classList.remove("uppercase");
        if (menuWrapper)
          menuWrapper.classList.remove("bg-white", "min-h-[234px]");
        if (mobileHeader) mobileHeader.classList.remove("bg-white");

        // Reset search input and show only first 4 products
        var searchInput = searchModal.querySelector('input[name="q"]');
        if (searchInput) {
          searchInput.value = "";
        }
        var productItems = searchModal.querySelectorAll(".search-product-item");
        productItems.forEach(function (item, index) {
          if (index < 4) {
            item.classList.remove("hidden");
          } else {
            item.classList.add("hidden");
          }
        });
      }

      // Close menu if it's open
      var menuTriggers = document.querySelectorAll("[data-menu]");
      var menuContents = document.querySelectorAll("[data-menu-content]");
      menuTriggers.forEach(function (menuElt) {
        menuElt.classList.remove("uppercase");
      });
      menuContents.forEach(function (content) {
        content.classList.add("opacity-0");
        content.classList.add("h-0");
      });
      if (menuWrapper) menuWrapper.classList.remove("min-h-[234px]");

      // Open cart
      miniCart.classList.remove("opacity-0", "pointer-events-none");
      miniCart.classList.add("opacity-100", "pointer-events-auto");
      cartTrigger.classList.add("uppercase");
      document.body.style.overflow = "hidden";
    }

    // Update header styles based on cart state
    updateHeaderStyles();
  }

  // toggle on cart button click
  cartTrigger.addEventListener("click", function (e) {
    e.stopPropagation(); // prevent this click from bubbling to document
    toggleMiniCart();
  });

  // close on clicking overlay
  if (miniCartOverlay) {
    miniCartOverlay.addEventListener("click", function () {
      toggleMiniCart();
    });
  }

  // close on clicking outside the mini cart
  document.addEventListener("click", function (e) {
    var isCartOpen = !miniCart.classList.contains("opacity-0");

    // only proceed if cart is open
    if (!isCartOpen) return;

    // check if click is outside mini cart
    if (!miniCart.contains(e.target) && !cartTrigger.contains(e.target)) {
      toggleMiniCart();
    }
  });

  // close on esc key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !miniCart.classList.contains("opacity-0")) {
      toggleMiniCart();
    }
  });

  // Initialize header styles based on initial cart state
  updateHeaderStyles();
});

// AJAX Cart Functionality
var AjaxCart = (function () {
  // Fetch cart data from Shopify
  function getCart() {
    return fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .catch(function (error) {
        console.error("Error fetching cart:", error);
      });
  }

  // Format money (Shopify format) - without trailing zeros
  function formatMoney(cents) {
    var price = (cents / 100).toFixed(2);
    // Remove trailing zeros and unnecessary decimal point
    price = price.replace(/\.00$/, "").replace(/(\.\d)0$/, "$1");

    // Get currency code from minicart data attribute
    var miniCart = document.querySelector("[data-mini-cart]");
    var currencyCode = "USD"; // default fallback
    if (miniCart) {
      var code = miniCart.getAttribute("data-currency-code");
      if (code) {
        currencyCode = code;
      }
    }

    // Currency symbol map (common currencies)
    var currencySymbols = {
      USD: "$",
      EUR: "€",
      GBP: "£",
      JPY: "¥",
      CAD: "C$",
      AUD: "A$",
      CHF: "CHF",
      CNY: "¥",
      INR: "₹",
      BRL: "R$",
      MXN: "$",
      KRW: "₩",
      SGD: "S$",
      HKD: "HK$",
      NZD: "NZ$",
      SEK: "kr",
      NOK: "kr",
      DKK: "kr",
      PLN: "zł",
      RUB: "₽",
      TRY: "₺",
      ZAR: "R",
    };

    var currencySymbol = currencySymbols[currencyCode] || currencyCode;

    // Some currencies put symbol after the amount
    var symbolAfter = ["kr", "zł"].includes(currencySymbol);

    if (symbolAfter) {
      return price + " " + currencySymbol;
    } else {
      return currencySymbol + price;
    }
  }

  // Render cart items
  function renderCart(cart) {
    var cartItemsContainer = document.querySelector("[data-cart-items]");
    var cartCountElement = document.querySelector("[data-cart-count]");
    var cartTotalElement = document.querySelector("[data-cart-total]");
    var cartShippingElement = document.querySelector("[data-cart-shipping]");
    var headerCartCount = document.querySelector("[data-header-cart-count]");
    var mobileHeaderCartCount = document.querySelector(
      "[data-mobile-header-cart-count]",
    );
    var miniCart = document.querySelector("[data-mini-cart]");

    if (!cartItemsContainer) return;

    // Update cart count and total
    if (cartCountElement) {
      cartCountElement.textContent = cart.item_count;
    }
    if (cartTotalElement) {
      cartTotalElement.textContent = formatMoney(cart.total_price);
    }
    // Update header cart count
    if (headerCartCount) {
      headerCartCount.textContent = cart.item_count;
    }
    // Update mobile header cart count
    if (mobileHeaderCartCount) {
      mobileHeaderCartCount.textContent = cart.item_count;
    }

    // Update free shipping message
    if (cartShippingElement && miniCart) {
      var currencyCode = miniCart.getAttribute("data-currency-code") || "USD";

      // Only show free shipping calculation for USD currency
      if (currencyCode === "USD") {
        var threshold = parseInt(
          miniCart.getAttribute("data-free-shipping-threshold") || 0,
          10,
        );
        var missing = threshold - cart.total_price;

        if (missing > 0) {
          cartShippingElement.textContent =
            formatMoney(missing) + " missing for free shipping";
        } else {
          cartShippingElement.textContent = "Free shipping included";
        }
      } else {
        cartShippingElement.textContent = "Calculated at checkout";
      }
    }

    // Clear existing items
    cartItemsContainer.innerHTML = "";

    // If cart is empty, show message
    if (cart.items.length === 0) {
      cartItemsContainer.innerHTML =
        '<div class="text-center py-8"><p>Your cart is empty</p></div>';
      return;
    }

    // Render each cart item
    cart.items.forEach(function (item, index) {
      var itemDiv = document.createElement("div");
      itemDiv.className = "grid grid-cols-4 gap-x-4";
      var lineNumber = index + 1; // Shopify uses 1-based indexing
      itemDiv.setAttribute("data-line-item", lineNumber);

      var imageHtml = "";
      if (item.image) {
        imageHtml =
          '<a href="' +
          item.url +
          '" class="block col-span-1">' +
          '<img src="' +
          item.image +
          '" alt="' +
          item.title +
          '" class="aspect-vertical h-full w-full object-cover v-bottom" />' +
          "</a>";
      }

      var variantTitle = item.variant_title || "";
      var productTitle = item.product_title || item.title;
      var fabricValue =
        item.properties && item.properties.Fabric ? item.properties.Fabric : "";

      // Build fabric HTML
      var fabricHtml = "";
      if (fabricValue) {
        fabricHtml = "<p>" + fabricValue + "</p>";
      }

      // Split variant title by ' / ' and create spans for each part
      var variantHtml = "";
      if (variantTitle && variantTitle !== "Default Title") {
        var splitTitle = variantTitle.split(" / ").reverse();
        variantHtml =
          '<div class="flex flex-row-reverse justify-end gap-x-2"><p>';
        splitTitle.forEach(function (part, index) {
          variantHtml += '<span class="">' + part + "</span>";
          if (index < splitTitle.length - 1) {
            variantHtml += " ";
          }
        });
        variantHtml += "</p></div>";
      }

      itemDiv.innerHTML =
        imageHtml +
        '<div class="col-span-2 h-full flex flex-col justify-between">' +
        '<div class="pt-3">' +
        "<h3>" +
        productTitle +
        "</h3>" +
        fabricHtml +
        "</div>" +
        variantHtml +
        "</div>" +
        '<div class="col-span-1 flex flex-col items-end justify-between">' +
        '<p class="pt-3">' +
        formatMoney(item.price) +
        "</p>" +
        '<div class="flex gap-x-2 items-center">' +
        '<button type="button" class="cart-item-remove hover:uppercase transition-all" data-line="' +
        lineNumber +
        '" aria-label="Remove item">Remove</button>' +
        '<button type="button" class="cart-quantity-minus" data-line="' +
        lineNumber +
        '" aria-label="Decrease quantity">-</button>' +
        '<input type="text" value="' +
        String(item.quantity).padStart(2, "0") +
        '" class="w-5 text-center pointer-events-none" />' +
        '<button type="button" class="cart-quantity-plus" data-line="' +
        lineNumber +
        '" aria-label="Increase quantity">+</button>' +
        "</div>" +
        "</div>";

      cartItemsContainer.appendChild(itemDiv);
    });

    // Add event listeners for quantity buttons and remove buttons
    attachCartEventListeners();
  }

  // Update cart item quantity
  function updateQuantity(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        line: parseInt(line, 10),
        quantity: parseInt(quantity, 10),
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Cart update failed: " + response.status);
        }
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      })
      .catch(function (error) {
        console.error("Error updating cart:", error);
        // Refresh cart to restore correct state
        getCart().then(function (cart) {
          renderCart(cart);
        });
      });
  }

  // Remove item from cart
  function removeItem(line) {
    return updateQuantity(line, 0);
  }

  // Attach event listeners to cart buttons
  function attachCartEventListeners() {
    // Quantity plus buttons
    document.querySelectorAll(".cart-quantity-plus").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var line = this.getAttribute("data-line");
        var qtyInput = this.previousElementSibling;
        var currentQty = parseInt(qtyInput.value, 10) || 1;
        updateQuantity(line, currentQty + 1);
      });
    });

    // Quantity minus buttons
    document.querySelectorAll(".cart-quantity-minus").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var line = this.getAttribute("data-line");
        var qtyInput = this.nextElementSibling;
        var currentQty = parseInt(qtyInput.value, 10) || 1;
        if (currentQty > 1) {
          updateQuantity(line, currentQty - 1);
        }
      });
    });

    // Remove buttons
    document.querySelectorAll(".cart-item-remove").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var line = this.getAttribute("data-line");
        removeItem(line);
      });
    });
  }

  // Add item to cart
  function addItem(variantId, quantity, properties) {
    var requestData = {
      id: variantId,
      quantity: quantity || 1,
    };

    if (properties) {
      requestData.properties = properties;
    }

    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || "Failed to add to cart");
          });
        }
        return response.json();
      })
      .then(function (item) {
        // Refresh cart after adding
        return getCart().then(function (cart) {
          renderCart(cart);
          return cart;
        });
      })
      .catch(function (error) {
        console.error("Error adding to cart:", error);
        throw error;
      });
  }

  // Open mini cart
  function openMiniCart() {
    var miniCart = document.querySelector("[data-mini-cart]");
    var miniCartOverlay = document.querySelector("[data-mini-cart-overlay]");
    var cartTrigger = document.querySelector("[data-cart]");
    var header = document.querySelector("header");
    var menuWrapper = document.querySelector(".menu-wrapper");
    var mobileHeader = document.querySelector("[data-mobile-header]");

    if (miniCart && !miniCart.classList.contains("opacity-100")) {
      // close search modal if it's open
      var searchModal = document.querySelector("[data-search-modal]");
      var searchTrigger = document.querySelector("[data-search]");
      if (searchModal && !searchModal.classList.contains("opacity-0")) {
        searchModal.classList.add("opacity-0", "pointer-events-none");
        searchModal.classList.remove("opacity-100", "pointer-events-auto");
        if (searchTrigger) searchTrigger.classList.remove("uppercase");
        if (menuWrapper)
          menuWrapper.classList.remove("bg-white", "min-h-[234px]");

        // reset search input and show only first 4 products
        var searchInput = searchModal.querySelector('input[name="q"]');
        if (searchInput) {
          searchInput.value = "";
        }
        var productItems = searchModal.querySelectorAll(".search-product-item");
        productItems.forEach(function (item, index) {
          if (index < 4) {
            item.classList.remove("hidden");
          } else {
            item.classList.add("hidden");
          }
        });
      }

      // close menu if it's open
      var menuTriggers = document.querySelectorAll("[data-menu]");
      var menuContents = document.querySelectorAll("[data-menu-content]");
      menuTriggers.forEach(function (menuElt) {
        menuElt.classList.remove("uppercase");
      });
      menuContents.forEach(function (content) {
        content.classList.add("opacity-0");
        content.classList.add("h-0");
      });
      if (menuWrapper) menuWrapper.classList.remove("min-h-[234px]");

      miniCart.classList.remove("opacity-0", "pointer-events-none");
      miniCart.classList.add("opacity-100", "pointer-events-auto");
      if (miniCartOverlay) {
        miniCartOverlay.classList.remove(
          "opacity-0",
          "pointer-events-none",
          "hidden",
        );
        miniCartOverlay.classList.add("opacity-100", "pointer-events-auto");
      }
      if (cartTrigger) cartTrigger.classList.add("uppercase");
      if (menuWrapper) menuWrapper.classList.add("bg-white");
      if (mobileHeader) mobileHeader.classList.add("bg-white");
      document.body.style.overflow = "hidden";
    }
  }

  // Initialize cart on page load
  function init() {
    getCart().then(function (cart) {
      renderCart(cart);
    });
  }

  // Public API
  return {
    init: init,
    getCart: getCart,
    renderCart: renderCart,
    addItem: addItem,
    updateQuantity: updateQuantity,
    removeItem: removeItem,
    openMiniCart: openMiniCart,
  };
})();

// Initialize AJAX cart on page load
document.addEventListener("DOMContentLoaded", function () {
  AjaxCart.init();
});

// Cart Page Functionality
document.addEventListener("DOMContentLoaded", function () {
  // Update cart quantity
  function updateCartPageQuantity(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Cart update failed: " + response.status);
        }
        return response.json();
      })
      .then(function (cart) {
        // Reload the page to show updated cart
        window.location.reload();
        return cart;
      })
      .catch(function (error) {
        console.error("Error updating cart:", error);
        window.location.reload();
      });
  }

  // Handle quantity increase
  document.querySelectorAll(".cart-page-quantity-plus").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = this.getAttribute("data-key");
      var input = document.querySelector('input[data-key="' + key + '"]');
      var currentQty = parseInt(input.getAttribute("data-quantity")) || 1;
      updateCartPageQuantity(key, currentQty + 1);
    });
  });

  // Handle quantity decrease
  document
    .querySelectorAll(".cart-page-quantity-minus")
    .forEach(function (btn) {
      btn.addEventListener("click", function () {
        var key = this.getAttribute("data-key");
        var input = document.querySelector('input[data-key="' + key + '"]');
        var currentQty = parseInt(input.getAttribute("data-quantity")) || 1;
        if (currentQty > 1) {
          updateCartPageQuantity(key, currentQty - 1);
        }
      });
    });

  // Handle remove item
  document.querySelectorAll(".cart-page-remove").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = this.getAttribute("data-key");
      updateCartPageQuantity(key, 0);
    });
  });
});

// product variant selection and add to cart
document.addEventListener("DOMContentLoaded", function () {
  var productForms = document.querySelectorAll(".product-form");
  if (productForms.length === 0) return;

  // initialize each form separately
  productForms.forEach(function (productForm) {
    var variantOptions = productForm.querySelectorAll(".variant-option");
    var variantIdInput = productForm.querySelector('input[name="id"]');
    var addToCartButton = productForm.querySelector('button[type="submit"]');
    var selectSizeButton = productForm.querySelector(
      "[data-select-size-button]",
    );
    var addToCartText = productForm.querySelector(".add-to-cart-text");
    var sizesWrapper = productForm.querySelector("[data-mobile-sizes-wrapper]");
    var isMobileForm = !!sizesWrapper;

    // function to show sizes wrapper with animation
    function showSizesWrapper() {
      if (!sizesWrapper) return;

      // get the natural height by temporarily removing height constraint
      var currentHeight = sizesWrapper.offsetHeight;
      sizesWrapper.style.height = "auto";
      var naturalHeight = sizesWrapper.scrollHeight;
      sizesWrapper.style.height = currentHeight + "px";

      // force reflow
      sizesWrapper.offsetHeight;

      // animate to natural height and fade in
      requestAnimationFrame(function () {
        sizesWrapper.style.height = naturalHeight + "px";
        sizesWrapper.style.opacity = "1";
        sizesWrapper.classList.remove("opacity-0");
      });
    }

    // function to update button to "Add to Cart"
    function updateButtonToAddToCart() {
      if (selectSizeButton && addToCartText) {
        selectSizeButton.type = "submit";
        selectSizeButton.removeAttribute("data-select-size-button");
        addToCartText.textContent =
          productForm.getAttribute("data-cart-label") || "Add to Cart";
      }
    }

    // handle "Select Size" button click
    if (selectSizeButton) {
      selectSizeButton.addEventListener("click", function (e) {
        // only prevent default if button still has the attribute
        if (this.hasAttribute("data-select-size-button")) {
          e.preventDefault();
          showSizesWrapper();

          // auto-select first available variant on mobile
          var firstAvailableVariant = productForm.querySelector(
            '.variant-option[data-available="true"]',
          );
          if (firstAvailableVariant && isMobileForm) {
            firstAvailableVariant.click();
          }
        }
      });
    }

    // handle variant selection
    variantOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        // remove selected state from all options in this form
        variantOptions.forEach(function (opt) {
          opt.classList.remove("border-b-[0.3px]");
        });

        // add selected state to clicked option
        this.classList.add("border-b-[0.3px]");

        // update hidden input with selected variant id
        var variantId = this.getAttribute("data-variant-id");
        variantIdInput.value = variantId;

        // for mobile form, update button to "Add to Cart" after size selection
        if (isMobileForm) {
          updateButtonToAddToCart();
        }

        // sync selection across all forms
        document.querySelectorAll(".product-form").forEach(function (form) {
          if (form !== productForm) {
            var otherVariantInput = form.querySelector('input[name="id"]');
            if (otherVariantInput) {
              otherVariantInput.value = variantId;
            }
            // sync visual selection
            form.querySelectorAll(".variant-option").forEach(function (opt) {
              opt.classList.remove("border-b-[0.3px]");
              if (opt.getAttribute("data-variant-id") === variantId) {
                opt.classList.add("border-b-[0.3px]");
              }
            });
          }
        });
      });
    });

    // check if size is already selected on mobile form (e.g., from URL param)
    if (isMobileForm) {
      var selectedOption = productForm.querySelector(
        ".variant-option.border-b-\\[0\\.3px\\]",
      );
      if (selectedOption) {
        // size already selected, show sizes and update button
        showSizesWrapper();
        updateButtonToAddToCart();
      }
    }

    // select first available variant by default (only for non-mobile forms)
    if (!isMobileForm) {
      var firstAvailableOption = productForm.querySelector(
        '.variant-option[data-available="true"]',
      );
      if (
        firstAvailableOption &&
        !productForm.querySelector(".variant-option.border-b-\\[0\\.3px\\]")
      ) {
        firstAvailableOption.click();
      }
    }

    // handle add to cart form submission
    productForm.addEventListener("submit", function (e) {
      e.preventDefault();

      var formData = new FormData(productForm);
      var variantId = formData.get("id");

      if (!variantId) {
        alert("Please select a size");
        return;
      }

      // get properties from form
      var properties = {};
      var fabricValue = formData.get("properties[Fabric]");
      if (fabricValue) {
        properties.Fabric = fabricValue;
      }

      // disable all add to cart buttons and show loading state
      document.querySelectorAll(".product-form").forEach(function (form) {
        var btn = form.querySelector('button[type="submit"]');
        var txt = form.querySelector(".add-to-cart-text");
        if (btn) btn.disabled = true;
        if (txt) txt.textContent = "Adding...";
      });

      // add to cart via ajax
      AjaxCart.addItem(variantId, 1, properties)
        .then(function (cart) {
          // success - update button text on all forms
          document.querySelectorAll(".product-form").forEach(function (form) {
            var txt = form.querySelector(".add-to-cart-text");
            if (txt) txt.textContent = "Added to Cart!";
          });

          // open mini cart
          AjaxCart.openMiniCart();

          // reset buttons after a short delay
          setTimeout(function () {
            document.querySelectorAll(".product-form").forEach(function (form) {
              var btn = form.querySelector('button[type="submit"]');
              var txt = form.querySelector(".add-to-cart-text");
              if (txt) {
                txt.textContent =
                  form.getAttribute("data-cart-label") || "Add to Cart";
              }
              if (btn) btn.disabled = false;
            });
          }, 1000);
        })
        .catch(function (error) {
          console.error("Error adding to cart:", error);
          // error - update all forms
          document.querySelectorAll(".product-form").forEach(function (form) {
            var btn = form.querySelector('button[type="submit"]');
            var txt = form.querySelector(".add-to-cart-text");
            if (txt) txt.textContent = "Error - Try Again";
            if (btn) btn.disabled = false;
          });

          // reset button text after 3 seconds
          setTimeout(function () {
            document.querySelectorAll(".product-form").forEach(function (form) {
              var txt = form.querySelector(".add-to-cart-text");
              if (txt) {
                txt.textContent =
                  form.getAttribute("data-cart-label") || "Add to Cart";
              }
            });
          }, 3000);
        });
    });
  });
});

// products block collection filter
document.addEventListener("DOMContentLoaded", function () {
  const filterCheckboxes = document.querySelectorAll(".collection-filter");
  const productItems = document.querySelectorAll(".product-item");

  if (filterCheckboxes.length === 0 || productItems.length === 0) return;

  function filterProducts() {
    // Get all checked filter values
    const checkedCollections = Array.from(filterCheckboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    // If no filters are selected, show first 8 products
    if (checkedCollections.length === 0) {
      let count = 0;
      productItems.forEach((item) => {
        if (count < 8) {
          item.style.display = "";
          count++;
        } else {
          item.style.display = "none";
        }
      });
      // update swiper if exists
      if (window.productsSwiperInstance) {
        window.productsSwiperInstance.update();
      }
      return;
    }

    // Show/hide products based on selected filters (max 8 visible)
    let visibleCount = 0;
    productItems.forEach((item) => {
      const collectionHandle = item.dataset.collectionHandle;
      if (checkedCollections.includes(collectionHandle) && visibleCount < 8) {
        item.style.display = "";
        visibleCount++;
      } else {
        item.style.display = "none";
      }
    });

    // update swiper if exists
    if (window.productsSwiperInstance) {
      window.productsSwiperInstance.update();
    }
  }

  // Add event listener to all checkboxes
  filterCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      // If trying to uncheck, prevent it (single selection - always keep one checked)
      if (!this.checked) {
        this.checked = true;
        return;
      }

      // Uncheck all other checkboxes
      filterCheckboxes.forEach((otherCheckbox) => {
        if (otherCheckbox !== checkbox) {
          otherCheckbox.checked = false;
        }
      });
      // Run filter
      filterProducts();
    });
  });

  // Run filter on page load to apply default checked filter
  filterProducts();
});

// dynamic list collection filter
document.addEventListener("DOMContentLoaded", function () {
  const filterCheckboxes = document.querySelectorAll(".dynamic-list-filter");
  const productItems = document.querySelectorAll(".dynamic-list-item");
  const dynamicListImage = document.getElementById("dynamic-list-image");
  const dynamicListDescription = document.getElementById(
    "dynamic-list-description",
  );
  const dynamicListLink = document.getElementById("dynamic-list-link");

  if (filterCheckboxes.length === 0 || productItems.length === 0) return;

  function updateImage() {
    if (!dynamicListImage) return;

    // Find the checked checkbox
    const checkedCheckbox = Array.from(filterCheckboxes).find(
      (checkbox) => checkbox.checked,
    );

    if (checkedCheckbox) {
      const collectionImage = checkedCheckbox.dataset.collectionImage;
      if (collectionImage) {
        dynamicListImage.src = collectionImage;
      } else {
        // Fallback to default image if no collection image
        const defaultImage = dynamicListImage.dataset.defaultImage;
        if (defaultImage) {
          dynamicListImage.src = defaultImage;
        }
      }
    } else {
      // No checkbox selected, use default image
      const defaultImage = dynamicListImage.dataset.defaultImage;
      if (defaultImage) {
        dynamicListImage.src = defaultImage;
      }
    }
  }

  function updateDescription() {
    if (!dynamicListDescription) return;

    // Find the checked checkbox
    const checkedCheckbox = Array.from(filterCheckboxes).find(
      (checkbox) => checkbox.checked,
    );

    if (checkedCheckbox) {
      const collectionDescription =
        checkedCheckbox.dataset.collectionDescription;
      if (collectionDescription) {
        dynamicListDescription.innerHTML = collectionDescription;
      } else {
        // Fallback to default description
        const defaultDescription =
          dynamicListDescription.dataset.defaultDescription;
        dynamicListDescription.innerHTML = defaultDescription || "";
      }
    } else {
      // No checkbox selected, use default description
      const defaultDescription =
        dynamicListDescription.dataset.defaultDescription;
      dynamicListDescription.innerHTML = defaultDescription || "";
    }
  }

  function updateLink() {
    if (!dynamicListLink) return;

    // Find the checked checkbox
    const checkedCheckbox = Array.from(filterCheckboxes).find(
      (checkbox) => checkbox.checked,
    );

    if (checkedCheckbox) {
      const collectionUrl = checkedCheckbox.dataset.collectionUrl;
      if (collectionUrl) {
        dynamicListLink.href = collectionUrl;
        dynamicListLink.textContent = "Shop";
      } else {
        // Fallback to default link
        const defaultUrl = dynamicListLink.dataset.defaultUrl;
        const defaultTitle = dynamicListLink.dataset.defaultTitle;
        if (defaultUrl) dynamicListLink.href = defaultUrl;
        if (defaultTitle) dynamicListLink.textContent = defaultTitle;
      }
    } else {
      // No checkbox selected, use default link
      const defaultUrl = dynamicListLink.dataset.defaultUrl;
      const defaultTitle = dynamicListLink.dataset.defaultTitle;
      if (defaultUrl) dynamicListLink.href = defaultUrl;
      if (defaultTitle) dynamicListLink.textContent = defaultTitle;
    }
  }

  function filterProducts() {
    // Get all checked filter values
    const checkedCollections = Array.from(filterCheckboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    // If no filters are selected, show first 6 products
    if (checkedCollections.length === 0) {
      let count = 0;
      productItems.forEach((item) => {
        if (count < 6) {
          item.style.display = "";
          count++;
        } else {
          item.style.display = "none";
        }
      });
      return;
    }

    // Show/hide products based on selected filters (max 6 visible)
    let visibleCount = 0;
    productItems.forEach((item) => {
      const productCollections = item.dataset.collectionHandles || "";
      const productCollectionArray = productCollections
        .split(",")
        .filter((handle) => handle.trim() !== "");

      // Check if product belongs to any of the selected collections
      const matches = checkedCollections.some((selectedCollection) =>
        productCollectionArray.includes(selectedCollection),
      );

      if (matches && visibleCount < 6) {
        item.style.display = "";
        visibleCount++;
      } else {
        item.style.display = "none";
      }
    });
  }

  // Add event listener to all checkboxes
  filterCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      // If trying to uncheck, prevent it (single selection - always keep one checked)
      if (!this.checked) {
        this.checked = true;
        return;
      }

      // Uncheck all other checkboxes (single selection mode)
      filterCheckboxes.forEach((otherCheckbox) => {
        if (otherCheckbox !== checkbox) {
          otherCheckbox.checked = false;
        }
      });
      // Update all dynamic content
      updateImage();
      updateDescription();
      updateLink();
      // Run filter
      filterProducts();
    });
  });

  // Run filter and update all content on page load to apply default checked filter
  updateImage();
  updateDescription();
  updateLink();
  filterProducts();
});

// countdown timer
document.addEventListener("DOMContentLoaded", function () {
  var countdownElements = document.querySelectorAll("[data-countdown-target]");
  if (countdownElements.length === 0) return;

  countdownElements.forEach(function (countdown) {
    var targetDate = countdown.getAttribute("data-countdown-target");
    if (!targetDate) return;

    var daysEl = countdown.querySelector(".countdown-days");
    var hoursEl = countdown.querySelector(".countdown-hours");
    var minutesEl = countdown.querySelector(".countdown-minutes");
    var secondsEl = countdown.querySelector(".countdown-seconds");

    function updateCountdown() {
      var now = new Date().getTime();
      var target = new Date(targetDate).getTime();
      var distance = target - now;

      if (distance < 0) {
        daysEl.textContent = "00 Days";
        hoursEl.textContent = "00 Hours";
        minutesEl.textContent = "00 Minutes";
        secondsEl.textContent = "00 Seconds";
        return;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysEl.textContent =
        String(days).padStart(2, "0") + (days === 1 ? " Day" : " Days");
      hoursEl.textContent =
        String(hours).padStart(2, "0") + (hours === 1 ? " Hour" : " Hours");
      minutesEl.textContent =
        String(minutes).padStart(2, "0") +
        (minutes === 1 ? " Minute" : " Minutes");
      secondsEl.textContent =
        String(seconds).padStart(2, "0") +
        (seconds === 1 ? " Second" : " Seconds");
    }

    // Update immediately
    updateCountdown();

    // Update every second
    setInterval(updateCountdown, 1000);
  });
});

// plp sort functionality
document.addEventListener("DOMContentLoaded", function () {
  var sortRadios = document.querySelectorAll('input[name="sort-option"]');
  var plpGrid = document.querySelector(".plp-grid");

  if (sortRadios.length === 0 || !plpGrid) return;

  // store original dom order for all grid children
  function assignOriginalIndexes() {
    Array.from(plpGrid.children).forEach(function (child, index) {
      if (!child.hasAttribute("data-original-index")) {
        child.setAttribute("data-original-index", index);
      }
    });
  }
  assignOriginalIndexes();

  document.addEventListener("plp:appended", function () {
    // continue indexes from current max so newest stays chronological
    var maxIndex = -1;
    Array.from(plpGrid.children).forEach(function (child) {
      var idx = parseInt(child.getAttribute("data-original-index"), 10);
      if (!isNaN(idx) && idx > maxIndex) maxIndex = idx;
    });
    Array.from(plpGrid.children).forEach(function (child) {
      if (!child.hasAttribute("data-original-index")) {
        maxIndex += 1;
        child.setAttribute("data-original-index", maxIndex);
      }
    });
  });

  sortRadios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      var sortContainer = this.closest("label").parentElement;
      var selectedLabel = this.closest("label");

      // uncheck other sort options
      sortRadios.forEach(function (otherRadio) {
        if (otherRadio !== radio) {
          otherRadio.checked = false;
        }
      });

      // Move selected option to first position
      if (sortContainer && selectedLabel) {
        sortContainer.insertBefore(selectedLabel, sortContainer.firstChild);
      }

      var sortValue = this.value;

      // Fade out
      plpGrid.style.transition = "opacity 200ms ease-out";
      plpGrid.style.opacity = "0";

      setTimeout(function () {
        var productItems = Array.from(
          plpGrid.querySelectorAll(".plp-product-item"),
        );
        var editorialBlocks = plpGrid.querySelectorAll(".plp-editorial");

        // check if any products are currently filtered (hidden)
        var hasActiveFilters = Array.from(productItems).some(function (item) {
          return item.style.display === "none";
        });

        // check if editorial blocks should be visible
        var shouldShowEditorials = !hasActiveFilters;

        // hide editorial blocks when sorting (except for newest with no filters)
        editorialBlocks.forEach(function (block) {
          block.style.display = "none";
        });

        // sort products based on selected option
        if (sortValue === "Newest") {
          // show editorial blocks for default/newest sort only if no filters
          if (shouldShowEditorials) {
            editorialBlocks.forEach(function (block) {
              block.style.display = "";
            });
          }

          // store current display state before re-ordering
          var displayStates = new Map();
          Array.from(plpGrid.children).forEach(function (child) {
            displayStates.set(child, child.style.display);
          });

          // restore original dom order for all children
          var allChildren = Array.from(plpGrid.children);
          allChildren.sort(function (a, b) {
            var indexA = parseInt(a.getAttribute("data-original-index")) || 0;
            var indexB = parseInt(b.getAttribute("data-original-index")) || 0;
            return indexA - indexB;
          });

          // re-append all children in original order and restore display state
          allChildren.forEach(function (child) {
            plpGrid.appendChild(child);
            // restore display state, but override for editorials if needed
            if (child.classList.contains("plp-editorial")) {
              child.style.display = shouldShowEditorials ? "" : "none";
            } else {
              child.style.display = displayStates.get(child);
            }
          });
        } else if (sortValue === "Bestselling") {
          // store current display state before sorting
          var displayStates = new Map();
          productItems.forEach(function (item) {
            displayStates.set(item, item.style.display);
          });

          // sort bestsellers first, then by index
          productItems.sort(function (a, b) {
            var isBestsellerA = a.getAttribute("data-bestseller") === "true";
            var isBestsellerB = b.getAttribute("data-bestseller") === "true";

            if (isBestsellerA && !isBestsellerB) return -1;
            if (!isBestsellerA && isBestsellerB) return 1;

            var indexA = parseInt(a.getAttribute("data-product-index")) || 0;
            var indexB = parseInt(b.getAttribute("data-product-index")) || 0;
            return indexA - indexB;
          });

          // re-append sorted products to grid and restore display state
          productItems.forEach(function (item) {
            plpGrid.appendChild(item);
            item.style.display = displayStates.get(item);
          });
        } else if (sortValue === "Price Low < High") {
          // store current display state before sorting
          var displayStates = new Map();
          productItems.forEach(function (item) {
            displayStates.set(item, item.style.display);
          });

          // sort by price ascending
          productItems.sort(function (a, b) {
            var priceA = parseInt(a.getAttribute("data-product-price")) || 0;
            var priceB = parseInt(b.getAttribute("data-product-price")) || 0;
            return priceA - priceB;
          });

          // re-append sorted products to grid and restore display state
          productItems.forEach(function (item) {
            plpGrid.appendChild(item);
            item.style.display = displayStates.get(item);
          });
        } else if (sortValue === "Price High > Low") {
          // store current display state before sorting
          var displayStates = new Map();
          productItems.forEach(function (item) {
            displayStates.set(item, item.style.display);
          });

          // sort by price descending
          productItems.sort(function (a, b) {
            var priceA = parseInt(a.getAttribute("data-product-price")) || 0;
            var priceB = parseInt(b.getAttribute("data-product-price")) || 0;
            return priceB - priceA;
          });

          // re-append sorted products to grid and restore display state
          productItems.forEach(function (item) {
            plpGrid.appendChild(item);
            item.style.display = displayStates.get(item);
          });
        }

        // Fade in
        setTimeout(function () {
          plpGrid.style.opacity = "1";
        }, 50);
      }, 200);
    });
  });
});

// PLP Filters Toggle
document.addEventListener("DOMContentLoaded", function () {
  var filterTrigger = document.querySelector("[data-filters]");
  var filterPanel = document.querySelector("[data-filters-panel]");
  var filterClose = document.querySelector("[data-filters-close]");

  if (!filterTrigger || !filterPanel) return;

  var isOpen = false;

  function closeFilters() {
    filterPanel.classList.add("opacity-0");
    filterPanel.style.height = filterPanel.scrollHeight + "px";
    setTimeout(function () {
      filterPanel.style.height = "0px";
    }, 10);
    filterTrigger.classList.remove("uppercase");
    filterTrigger.classList.add("border-b-[0.3px]");

    isOpen = false;
  }

  function openFilters() {
    filterPanel.style.height = filterPanel.scrollHeight + "px";
    filterTrigger.classList.add("uppercase");
    filterTrigger.classList.remove("border-b-[0.3px]");
    isOpen = true;

    // Delay opacity fade-in to create staggered effect
    setTimeout(function () {
      filterPanel.classList.remove("opacity-0");
    }, 150);

    // Reset to auto after transition completes
    setTimeout(function () {
      if (isOpen) {
        filterPanel.style.height = "auto";
      }
    }, 500); // Match the transition duration
  }

  filterTrigger.addEventListener("click", function () {
    if (isOpen) {
      closeFilters();
    } else {
      openFilters();
    }
  });

  if (filterClose) {
    filterClose.addEventListener("click", function () {
      if (isOpen) {
        closeFilters();
      }
    });
  }
});

// PLP Collection Filtering with Smart Option Disabling
document.addEventListener("DOMContentLoaded", function () {
  var applyButton = document.querySelector("[data-filters-apply]");
  var resetButton = document.querySelector("[data-filters-reset]");
  var plpGrid = document.querySelector(".plp-grid");

  if (!applyButton || !resetButton || !plpGrid) return;
  if (plpGrid.querySelectorAll(".plp-product-item").length === 0) return;

  function getProductItems() {
    return plpGrid.querySelectorAll(".plp-product-item");
  }
  function getEditorialBlocks() {
    return plpGrid.querySelectorAll(".plp-editorial");
  }

  // Helper function to normalize filter values like Shopify's handleize
  function normalizeFilterValue(value) {
    return value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric chars with hyphens
      .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
  }

  // Build product filter data structure
  var productData = [];
  function rebuildProductData() {
    productData = [];
    getProductItems().forEach(function (item) {
      var product = {
        element: item,
        gender: [],
        color: [],
        fabric: [],
        size: [],
      };

      item.classList.forEach(function (className) {
        if (className.startsWith("gender-")) {
          product.gender.push(className.replace("gender-", ""));
        } else if (className.startsWith("color-")) {
          product.color.push(className.replace("color-", ""));
        } else if (className.startsWith("fabric-")) {
          product.fabric.push(className.replace("fabric-", ""));
        } else if (className.startsWith("size-")) {
          product.size.push(className.replace("size-", ""));
        }
      });

      productData.push(product);
    });
  }
  rebuildProductData();

  var isSeekingMatches = false;

  document.addEventListener("plp:appended", function () {
    rebuildProductData();
    updateAvailableOptions();
    if (hasAnyActiveFilters()) {
      applyFilters(false);
    }
  });

  function hasAnyActiveFilters() {
    var selectors = [
      'input[name="plp-filter-gender[]"]:checked',
      'input[name="plp-filter-color[]"]:checked',
      'input[name="plp-filter-fabric[]"]:checked',
      'input[name="plp-filter-size[]"]:checked',
    ];
    return selectors.some(function (selector) {
      return Array.from(document.querySelectorAll(selector)).some(
        function (cb) {
          return cb.value !== "All";
        },
      );
    });
  }

  function countVisibleProducts() {
    return Array.from(getProductItems()).filter(function (item) {
      return item.style.display !== "none";
    }).length;
  }

  function canLoadMoreProducts() {
    var sentinel = document.querySelector("[data-plp-load-more]");
    return !!(sentinel && sentinel.getAttribute("data-next-url"));
  }

  function fadeGridIn() {
    plpGrid.style.transition = "opacity 200ms ease-out";
    setTimeout(function () {
      plpGrid.style.opacity = "1";
    }, 50);
  }

  // load more pages while faded until matches appear
  function seekMatchesThenFadeIn() {
    isSeekingMatches = true;
    plpGrid.style.opacity = "0";

    function step() {
      if (countVisibleProducts() > 0 || !canLoadMoreProducts()) {
        isSeekingMatches = false;
        fadeGridIn();
        return;
      }

      document.dispatchEvent(
        new CustomEvent("plp:request-next-page", {
          detail: {
            callback: function (ok) {
              if (ok === false) {
                isSeekingMatches = false;
                fadeGridIn();
                return;
              }
              step();
            },
          },
        }),
      );
    }

    step();
  }

  function collectSelectedFilters() {
    var selectedFilters = {
      gender: [],
      color: [],
      fabric: [],
      size: [],
    };

    document
      .querySelectorAll('input[name="plp-filter-gender[]"]:checked')
      .forEach(function (checkbox) {
        if (checkbox.value !== "All") {
          selectedFilters.gender.push(
            "gender-" + normalizeFilterValue(checkbox.value),
          );
        }
      });
    document
      .querySelectorAll('input[name="plp-filter-color[]"]:checked')
      .forEach(function (checkbox) {
        if (checkbox.value !== "All") {
          selectedFilters.color.push(
            "color-" + normalizeFilterValue(checkbox.value),
          );
        }
      });
    document
      .querySelectorAll('input[name="plp-filter-fabric[]"]:checked')
      .forEach(function (checkbox) {
        if (checkbox.value !== "All") {
          selectedFilters.fabric.push(
            "fabric-" + normalizeFilterValue(checkbox.value),
          );
        }
      });
    document
      .querySelectorAll('input[name="plp-filter-size[]"]:checked')
      .forEach(function (checkbox) {
        if (checkbox.value !== "All") {
          selectedFilters.size.push(
            "size-" + normalizeFilterValue(checkbox.value),
          );
        }
      });

    return selectedFilters;
  }

  function applyFilters(animate) {
    if (!plpGrid) return;

    function run() {
      var selectedFilters = collectSelectedFilters();
      var hasActiveFilters =
        selectedFilters.gender.length > 0 ||
        selectedFilters.color.length > 0 ||
        selectedFilters.fabric.length > 0 ||
        selectedFilters.size.length > 0;

      getProductItems().forEach(function (item) {
        var shouldShow = true;

        if (selectedFilters.gender.length > 0) {
          var hasGenderMatch = selectedFilters.gender.some(
            function (genderClass) {
              return item.classList.contains(genderClass);
            },
          );
          if (!hasGenderMatch) shouldShow = false;
        }

        if (selectedFilters.color.length > 0) {
          var hasColorMatch = selectedFilters.color.some(function (colorClass) {
            return item.classList.contains(colorClass);
          });
          if (!hasColorMatch) shouldShow = false;
        }

        if (selectedFilters.fabric.length > 0) {
          var hasFabricMatch = selectedFilters.fabric.some(
            function (fabricClass) {
              return item.classList.contains(fabricClass);
            },
          );
          if (!hasFabricMatch) shouldShow = false;
        }

        if (selectedFilters.size.length > 0) {
          var hasSizeMatch = selectedFilters.size.some(function (sizeClass) {
            return item.classList.contains(sizeClass);
          });
          if (!hasSizeMatch) shouldShow = false;
        }

        item.style.display = shouldShow ? "" : "none";
      });

      var editorialBlocks = getEditorialBlocks();
      editorialBlocks.forEach(function (block) {
        block.style.display = hasActiveFilters ? "none" : "";
      });

      // stay faded while we fetch pages that may hold matches
      if (
        animate &&
        hasActiveFilters &&
        countVisibleProducts() === 0 &&
        canLoadMoreProducts()
      ) {
        seekMatchesThenFadeIn();
        return;
      }

      if (animate && !isSeekingMatches) {
        fadeGridIn();
      }
    }

    if (animate) {
      plpGrid.style.transition = "opacity 200ms ease-out";
      plpGrid.style.opacity = "0";
      setTimeout(run, 200);
    } else {
      run();
    }
  }

  // keep all liquid-rendered options active (pagination loads products later)
  function updateAvailableOptions() {
    document.querySelectorAll("[data-filter-option]").forEach(function (label) {
      label.style.opacity = "1";
      label.style.pointerEvents = "auto";
    });
  }

  // Handle filter checkbox interactions
  var filterGroups = [
    'input[name="plp-filter-gender[]"]',
    'input[name="plp-filter-color[]"]',
    'input[name="plp-filter-fabric[]"]',
    'input[name="plp-filter-size[]"]',
  ];

  filterGroups.forEach(function (selector) {
    var checkboxes = document.querySelectorAll(selector);

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener("change", function () {
        var allCheckbox = Array.from(checkboxes).find(function (cb) {
          return cb.value === "All";
        });

        if (this.value === "All") {
          // If "All" is checked, uncheck all others
          if (this.checked) {
            checkboxes.forEach(function (cb) {
              if (cb.value !== "All") {
                cb.checked = false;
              }
            });
          }
        } else {
          // If any specific filter is checked, uncheck "All"
          if (this.checked && allCheckbox) {
            allCheckbox.checked = false;
          }

          // If all specific filters are unchecked, check "All"
          var anySpecificChecked = Array.from(checkboxes).some(function (cb) {
            return cb.value !== "All" && cb.checked;
          });

          if (!anySpecificChecked && allCheckbox) {
            allCheckbox.checked = true;
          }
        }

        // Update available options after filter change
        updateAvailableOptions();
      });
    });
  });

  // Apply filters
  applyButton.addEventListener("click", function () {
    applyFilters(true);
  });

  // reset filters
  resetButton.addEventListener("click", function () {
    if (!plpGrid) return;

    // fade out
    plpGrid.style.transition = "opacity 200ms ease-out";
    plpGrid.style.opacity = "0";

    setTimeout(function () {
      // uncheck all checkboxes except "all"
      var allCheckboxes = document.querySelectorAll(
        'input[name="plp-filter-gender[]"], input[name="plp-filter-color[]"], input[name="plp-filter-fabric[]"], input[name="plp-filter-size[]"]',
      );

      allCheckboxes.forEach(function (checkbox) {
        if (checkbox.value === "All") {
          checkbox.checked = true;
        } else {
          checkbox.checked = false;
        }
      });

      // restore original dom order for all children
      var allChildren = Array.from(plpGrid.children);
      allChildren.sort(function (a, b) {
        var indexA = parseInt(a.getAttribute("data-original-index")) || 0;
        var indexB = parseInt(b.getAttribute("data-original-index")) || 0;
        return indexA - indexB;
      });

      // re-append all children in original order
      allChildren.forEach(function (child) {
        plpGrid.appendChild(child);
      });

      // show all products
      getProductItems().forEach(function (item) {
        item.style.display = "";
      });

      // show all editorial blocks
      getEditorialBlocks().forEach(function (block) {
        block.style.display = "";
      });

      // reset available options
      updateAvailableOptions();

      // fade in
      setTimeout(function () {
        plpGrid.style.opacity = "1";
      }, 50);
    }, 200);
  });

  // Initialize available options on page load
  updateAvailableOptions();
});

// plp infinite scroll
document.addEventListener("DOMContentLoaded", function () {
  var plpGrid = document.querySelector("[data-plp-grid]");
  var sentinel = document.querySelector("[data-plp-load-more]");

  if (!plpGrid || !sentinel || !("IntersectionObserver" in window)) return;

  var isLoading = false;
  var pendingCallbacks = [];

  function finishPagination() {
    if (observer) observer.disconnect();
    if (sentinel && sentinel.parentNode) sentinel.remove();
    var spacer = document.createElement("div");
    spacer.className = "mb-22 md:mb-24";
    plpGrid.insertAdjacentElement("afterend", spacer);
    sentinel = null;
  }

  function flushCallbacks(ok) {
    var callbacks = pendingCallbacks.slice();
    pendingCallbacks = [];
    callbacks.forEach(function (cb) {
      if (typeof cb === "function") cb(ok);
    });
  }

  function loadNextPage(callback) {
    if (typeof callback === "function") pendingCallbacks.push(callback);

    if (isLoading) return;

    if (!sentinel) {
      flushCallbacks(true);
      return;
    }

    var nextUrl = sentinel.getAttribute("data-next-url");
    if (!nextUrl) {
      finishPagination();
      flushCallbacks(true);
      return;
    }

    isLoading = true;
    var succeeded = false;

    fetch(nextUrl)
      .then(function (response) {
        if (!response.ok) throw new Error("load more failed");
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var nextGrid = doc.querySelector("[data-plp-grid]");
        if (!nextGrid) throw new Error("next grid missing");

        Array.from(nextGrid.children).forEach(function (child) {
          plpGrid.appendChild(child);
        });

        document.dispatchEvent(new CustomEvent("plp:appended"));

        var nextSentinel = doc.querySelector("[data-plp-load-more]");
        if (
          sentinel &&
          nextSentinel &&
          nextSentinel.getAttribute("data-next-url")
        ) {
          sentinel.setAttribute(
            "data-next-url",
            nextSentinel.getAttribute("data-next-url"),
          );
        } else {
          finishPagination();
        }
        succeeded = true;
      })
      .catch(function () {
        // keep sentinel so scroll can retry
      })
      .finally(function () {
        isLoading = false;
        flushCallbacks(succeeded);
      });
  }

  document.addEventListener("plp:request-next-page", function (event) {
    var callback = event.detail && event.detail.callback;
    loadNextPage(callback);
  });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNextPage();
      });
    },
    { rootMargin: "800px 0px" },
  );

  observer.observe(sentinel);
});

// Cookie Management System
var CookieManager = (function () {
  // Set a cookie with expiry days
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  // Get a cookie value
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Delete a cookie
  function deleteCookie(name) {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  }

  // Check if a cookie exists and is not expired
  function isCookieValid(name) {
    var value = getCookie(name);
    return value !== null && value !== "";
  }

  // Set cookie consent preferences
  function setCookieConsent(preferences) {
    var consentData = {
      required: preferences.required || "yes",
      marketing: preferences.marketing || "no",
      personalisation: preferences.personalisation || "no",
      analytics: preferences.analytics || "no",
      timestamp: new Date().toISOString(),
    };
    setCookie("cookie_consent", JSON.stringify(consentData), 365);
  }

  // Get cookie consent preferences
  function getCookieConsent() {
    var consentData = getCookie("cookie_consent");
    if (!consentData) return null;

    try {
      return JSON.parse(consentData);
    } catch (e) {
      return null;
    }
  }

  // Check if user has given consent
  function hasConsent() {
    return isCookieValid("cookie_consent");
  }

  // Public API
  return {
    setCookie: setCookie,
    getCookie: getCookie,
    deleteCookie: deleteCookie,
    isCookieValid: isCookieValid,
    setCookieConsent: setCookieConsent,
    getCookieConsent: getCookieConsent,
    hasConsent: hasConsent,
  };
})();

// Newsletter Popup
document.addEventListener("DOMContentLoaded", function () {
  var newsletterPopup = document.querySelector(".newsletter-popup");
  var closeButton = document.querySelector(".newsletter-popup-close");

  if (!newsletterPopup) return;

  var POPUP_COOKIE_NAME = "newsletter_popup_closed";
  var POPUP_EXPIRY_DAYS = 30;

  // Check if popup was previously closed
  function isPopupClosed() {
    return CookieManager.isCookieValid(POPUP_COOKIE_NAME);
  }

  // Check if cookies popup is currently visible
  function isCookiesPopupVisible() {
    var cookiesPopup = document.getElementById("cookies-popup");
    if (!cookiesPopup) return false;
    return !cookiesPopup.classList.contains("opacity-0");
  }

  // Show popup
  function showPopup() {
    // Don't show if cookies popup is visible
    if (isCookiesPopupVisible()) {
      return;
    }
    newsletterPopup.classList.remove("opacity-0", "pointer-events-none");
    newsletterPopup.classList.add("opacity-100", "pointer-events-auto");
    document.body.style.overflow = "hidden";
  }

  // Hide popup
  function hidePopup() {
    newsletterPopup.classList.remove("opacity-100", "pointer-events-auto");
    newsletterPopup.classList.add("opacity-0", "pointer-events-none");
    document.body.style.overflow = "";
  }

  // Close popup and set expiry
  function closePopup() {
    hidePopup();
    CookieManager.setCookie(POPUP_COOKIE_NAME, "closed", POPUP_EXPIRY_DAYS);
  }

  // Show popup after 4 seconds if not previously closed
  if (!isPopupClosed()) {
    setTimeout(function () {
      showPopup();
    }, 4000);
  }

  // Listen for when cookies popup is closed to potentially show newsletter popup
  document.addEventListener("cookiesPopupClosed", function () {
    if (!isPopupClosed() && !isCookiesPopupVisible()) {
      setTimeout(function () {
        showPopup();
      }, 1000);
    }
  });

  // Close button event listener
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      closePopup();
    });
  }

  // Close on ESC key
  document.addEventListener("keydown", function (e) {
    if (
      e.key === "Escape" &&
      newsletterPopup.classList.contains("opacity-100")
    ) {
      closePopup();
    }
  });

  // Close on clicking backdrop (outside the white panel)
  newsletterPopup.addEventListener("click", function (e) {
    if (e.target === newsletterPopup) {
      closePopup();
    }
  });
});

// tabs block
document.addEventListener("DOMContentLoaded", function () {
  var tabButtons = document.querySelectorAll(".tabs-block .tab-header");
  var tabContents = document.querySelectorAll(".tabs-block .tab-content");

  tabButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var currentTab = btn.getAttribute("data-tab");

      // Update header selected state
      tabButtons.forEach(function (b) {
        b.setAttribute("aria-selected", b === btn ? "true" : "false");
      });

      // Show/hide content
      tabContents.forEach(function (content) {
        if (content.getAttribute("data-tab-content") === currentTab) {
          content.classList.remove("hidden");
          content.classList.add("block");
        } else {
          content.classList.remove("block");
          content.classList.add("hidden");
        }
      });
    });
  });

  // Convert <ol> elements to accordions
  var tabsBlock = document.querySelector(".tabs-block");
  if (tabsBlock) {
    var orderedLists = tabsBlock.querySelectorAll("ol");

    orderedLists.forEach(function (ol, olIndex) {
      var accordionHtml = '<div class="accordion-group">';
      var listItems = ol.querySelectorAll("li");

      listItems.forEach(function (li, index) {
        var content = li.innerHTML;
        var title = "";
        var body = "";

        // Extract bold text as title
        var strongMatch = content.match(
          /<strong>(.*?)<\/strong>|<b>(.*?)<\/b>/,
        );
        if (strongMatch) {
          title = strongMatch[1] || strongMatch[2];
          // Remove the bold tags and get the rest as body
          body = content
            .replace(/<strong>.*?<\/strong>|<b>.*?<\/b>/, "")
            .trim();
        } else {
          // If no bold text, use entire content
          title = content;
          body = "";
        }

        var uniqueId = "accordion_" + olIndex + "_" + index;

        accordionHtml += '<div class="accordion-item mb-2">';
        accordionHtml +=
          '  <label class="group inline-flex items-baseline cursor-pointer gap-2 select-none">';
        accordionHtml +=
          '    <input type="checkbox" class="sr-only peer accordion-toggle" data-accordion-id="' +
          uniqueId +
          '">';
        accordionHtml +=
          '    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg" class="peer-checked:[&>g>rect:last-child]:opacity-100 group-hover:[&>g>rect:last-child]:opacity-100">';
        accordionHtml +=
          '      <g clip-path="url(#clip0_accordion_' + uniqueId + ')">';
        accordionHtml +=
          '        <path d="M8.2998 1.0835V8.68311H0.700195V1.0835H8.2998Z" stroke="#282828" stroke-width="0.4"/>';
        accordionHtml +=
          '        <rect class="opacity-0" x="7.94922" y="1.04492" width="0.550196" height="10.306" transform="rotate(45 7.94922 1.04492)" fill="#282828"/>';
        accordionHtml += "      </g>";
        accordionHtml += "      <defs>";
        accordionHtml +=
          '        <clipPath id="clip0_accordion_' + uniqueId + '">';
        accordionHtml +=
          '          <rect width="8" height="8" fill="white" transform="translate(0.5 0.883301)"/>';
        accordionHtml += "        </clipPath>";
        accordionHtml += "      </defs>";
        accordionHtml += "    </svg>";
        accordionHtml +=
          '    <span class="peer-checked:uppercase peer-checked:border-0 border-b-[0.3px] border-black leading-none">' +
          title +
          "</span>";
        accordionHtml += "  </label>";
        if (body) {
          accordionHtml +=
            '  <div class="accordion-content hidden mb-8" data-accordion-content="' +
            uniqueId +
            '">' +
            body +
            "</div>";
        }
        accordionHtml += "</div>";
      });

      accordionHtml += "</div>";

      // Replace the <ol> with the accordion
      ol.outerHTML = accordionHtml;
    });

    // Add event listeners for accordion toggles
    var accordionToggles = tabsBlock.querySelectorAll(".accordion-toggle");
    accordionToggles.forEach(function (toggle) {
      toggle.addEventListener("change", function () {
        var accordionId = toggle.getAttribute("data-accordion-id");
        var content = tabsBlock.querySelector(
          '[data-accordion-content="' + accordionId + '"]',
        );

        if (content) {
          if (toggle.checked) {
            content.classList.remove("hidden");
            content.classList.add("block");
          } else {
            content.classList.remove("block");
            content.classList.add("hidden");
          }
        }
      });
    });
  }
});

// pdp accordions
document.addEventListener("DOMContentLoaded", function () {
  var pdpAccordionTriggers = document.querySelectorAll(
    ".pdp-accordion-trigger",
  );

  if (pdpAccordionTriggers.length === 0) return;

  var isOpen = false;

  pdpAccordionTriggers.forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var accordionId = this.getAttribute("data-accordion");
      var content = document.querySelector(
        '.pdp-accordion-content[data-accordion-content="' + accordionId + '"]',
      );

      if (!content) return;

      var isCurrentlyOpen =
        content.style.height && content.style.height !== "0px";

      if (isCurrentlyOpen) {
        // Close accordion
        content.classList.add("opacity-0");
        content.style.height = content.scrollHeight + "px";
        setTimeout(function () {
          content.style.height = "0px";
        }, 10);
        trigger.classList.add("border-b-[0.3px]", "border-black");
        trigger.classList.remove("uppercase", "border-0");
        isOpen = false;
      } else {
        // Close all other accordions first
        pdpAccordionTriggers.forEach(function (otherTrigger) {
          if (otherTrigger !== trigger) {
            var otherAccordionId = otherTrigger.getAttribute("data-accordion");
            var otherContent = document.querySelector(
              '.pdp-accordion-content[data-accordion-content="' +
                otherAccordionId +
                '"]',
            );
            if (otherContent && otherContent.style.height !== "0px") {
              otherContent.classList.add("opacity-0");
              otherContent.style.height = otherContent.scrollHeight + "px";
              setTimeout(function () {
                otherContent.style.height = "0px";
              }, 10);
              otherTrigger.classList.add("border-b-[0.3px]", "border-black");
              otherTrigger.classList.remove("uppercase", "border-0");
            }
          }
        });

        // Open this accordion
        content.style.height = content.scrollHeight + "px";
        trigger.classList.remove("border-b-[0.3px]", "border-black");
        trigger.classList.add("uppercase", "border-0");
        isOpen = true;

        // Delay opacity fade-in to create staggered effect
        setTimeout(function () {
          content.classList.remove("opacity-0");
        }, 150);

        // Set to auto after transition completes
        setTimeout(function () {
          if (isOpen) {
            content.style.height = "auto";
          }
        }, 500); // Match the transition duration
      }
    });
  });
});

// size guide toggle
document.addEventListener("DOMContentLoaded", function () {
  var sizeGuideTriggers = document.querySelectorAll(
    "[data-size-guide-trigger], [data-size-guide-trigger-mobile]",
  );
  var sizeGuidesContainers = document.querySelectorAll(".size-guides");

  if (sizeGuideTriggers.length === 0 || sizeGuidesContainers.length === 0)
    return;

  // helper function to find the closest size-guides container to a trigger
  function findClosestSizeGuideContainer(trigger) {
    var triggerParent = trigger.closest(
      ".product-form-container-mobile, .product-form-container",
    );
    var isMobileTrigger =
      triggerParent &&
      triggerParent.classList.contains("product-form-container-mobile");

    // mobile trigger: find size-guides within or immediately after mobile form container
    if (isMobileTrigger && triggerParent) {
      // first check if size-guides is inside the mobile form container
      var containerInMobile = triggerParent.querySelector(".size-guides");
      if (containerInMobile) {
        return containerInMobile;
      }
      // check if size-guides is a sibling after the mobile form
      var nextSibling = triggerParent.nextElementSibling;
      while (nextSibling) {
        if (nextSibling.classList.contains("size-guides")) {
          return nextSibling;
        }
        nextSibling = nextSibling.nextElementSibling;
      }
    }

    // desktop trigger: find size-guides that's not in mobile container
    if (!isMobileTrigger) {
      for (var i = 0; i < sizeGuidesContainers.length; i++) {
        var container = sizeGuidesContainers[i];
        // skip if container is inside mobile form container
        var mobileParent = container.closest(".product-form-container-mobile");
        if (!mobileParent && container.offsetParent !== null) {
          return container;
        }
      }
    }

    // fallback: find first visible container
    for (var i = 0; i < sizeGuidesContainers.length; i++) {
      if (sizeGuidesContainers[i].offsetParent !== null) {
        return sizeGuidesContainers[i];
      }
    }

    return sizeGuidesContainers[0];
  }

  // track open state per container
  var containerStates = new Map();

  // add click listener to all triggers
  sizeGuideTriggers.forEach(function (sizeGuideTrigger) {
    sizeGuideTrigger.addEventListener("click", function () {
      var isMobile = window.innerWidth < 768;
      var sizeGuidesContainer = findClosestSizeGuideContainer(sizeGuideTrigger);

      if (!sizeGuidesContainer) return;

      // for mobile trigger, make sure the sizes wrapper is open first
      if (
        isMobile &&
        sizeGuideTrigger.hasAttribute("data-size-guide-trigger-mobile")
      ) {
        var sizesWrapper = sizeGuideTrigger.closest(
          "[data-mobile-sizes-wrapper]",
        );
        var currentHeight = sizesWrapper ? sizesWrapper.style.height : "";
        // check if wrapper is collapsed (height is 0 or 0px)
        if (
          sizesWrapper &&
          (currentHeight === "0" || currentHeight === "0px")
        ) {
          // open the sizes wrapper first
          sizesWrapper.style.height = "auto";
          var naturalHeight = sizesWrapper.scrollHeight;
          sizesWrapper.style.height = "0px";
          requestAnimationFrame(function () {
            sizesWrapper.style.height = naturalHeight + "px";
            sizesWrapper.style.opacity = "1";
            sizesWrapper.classList.remove("opacity-0");
          });
        }
      }

      var isSizeGuideOpen = containerStates.get(sizeGuidesContainer) || false;

      if (isSizeGuideOpen) {
        // close size guide
        if (isMobile) {
          sizeGuidesContainer.style.maxHeight = "0px";
        }
        sizeGuidesContainer.classList.add("opacity-0", "pointer-events-none");
        sizeGuidesContainer.classList.remove(
          "opacity-100",
          "pointer-events-auto",
        );
        // update text on clicked trigger
        sizeGuideTrigger.textContent = "Size Guide";
        containerStates.set(sizeGuidesContainer, false);
      } else {
        // open size guide
        if (isMobile) {
          sizeGuidesContainer.style.maxHeight = "300px";
        }
        sizeGuidesContainer.classList.remove(
          "opacity-0",
          "pointer-events-none",
        );
        sizeGuidesContainer.classList.add("opacity-100", "pointer-events-auto");
        // update text on clicked trigger
        sizeGuideTrigger.textContent = "Collapse Size Guide";
        containerStates.set(sizeGuidesContainer, true);
      }
    });
  });
});

// Cookies Popup
document.addEventListener("DOMContentLoaded", function () {
  var cookiesPopup = document.getElementById("cookies-popup");
  var simpleView = document.getElementById("cookies-simple-view");
  var detailedView = document.getElementById("cookies-detailed-view");
  var simpleButtons = document.getElementById("cookies-simple-buttons");
  var detailedButtons = document.getElementById("cookies-detailed-buttons");
  var acceptButton = document.querySelector(".cookies-accept");
  var declineButton = document.querySelector(".cookies-decline");
  var manageSettingsButton = document.querySelector(".cookies-manage-settings");
  var manageSettingsDetailedButton = document.querySelector(
    ".cookies-manage-settings-detailed",
  );
  var closeButtonSimple = document.querySelector(".cookies-popup-close-simple");
  var closeButton = document.querySelector(".cookies-popup-close");
  var allowAllButton = document.querySelector(".cookies-allow-all");
  var allowNecessaryButton = document.querySelector(".cookies-allow-necessary");

  if (!cookiesPopup) return;

  var COOKIES_POPUP_COOKIE_NAME = "cookies_popup_shown";
  var COOKIES_POPUP_EXPIRY_DAYS = 365;

  // Check if cookies popup was previously shown
  function isCookiesPopupShown() {
    return CookieManager.isCookieValid(COOKIES_POPUP_COOKIE_NAME);
  }

  // Show cookies popup
  function showCookiesPopup() {
    cookiesPopup.classList.remove("opacity-0", "pointer-events-none");
    cookiesPopup.classList.add("opacity-100", "pointer-events-auto");
    document.body.style.overflow = "hidden";
  }

  // Hide cookies popup
  function hideCookiesPopup() {
    cookiesPopup.classList.remove("opacity-100", "pointer-events-auto");
    cookiesPopup.classList.add("opacity-0", "pointer-events-none");
    document.body.style.overflow = "";
    // Reset to simple view when closing
    showSimpleView();
  }

  // show simple view
  function showSimpleView() {
    if (simpleView) simpleView.classList.remove("hidden");
    if (detailedView) detailedView.classList.add("hidden");
    if (simpleButtons) simpleButtons.classList.remove("hidden");
    if (detailedButtons) detailedButtons.classList.add("hidden");
  }

  // show detailed view
  function showDetailedView() {
    if (simpleView) simpleView.classList.add("hidden");
    if (detailedView) detailedView.classList.remove("hidden");
    if (simpleButtons) simpleButtons.classList.add("hidden");
    if (detailedButtons) detailedButtons.classList.remove("hidden");
  }

  // Get current cookie preferences
  function getCurrentPreferences() {
    var required = document.querySelector(
      'input[name="required-cookies"]:checked',
    );
    var marketing = document.querySelector(
      'input[name="marketing-cookies"]:checked',
    );
    var personalisation = document.querySelector(
      'input[name="personalisation-cookies"]:checked',
    );
    var analytics = document.querySelector(
      'input[name="analytics-cookies"]:checked',
    );

    return {
      required: required ? required.value : "yes",
      marketing: marketing ? marketing.value : "no",
      personalisation: personalisation ? personalisation.value : "no",
      analytics: analytics ? analytics.value : "no",
    };
  }

  // Set all cookies to yes
  function setAllCookiesToYes() {
    var radioGroups = [
      'input[name="required-cookies"][value="yes"]',
      'input[name="marketing-cookies"][value="yes"]',
      'input[name="personalisation-cookies"][value="yes"]',
      'input[name="analytics-cookies"][value="yes"]',
    ];

    radioGroups.forEach(function (selector) {
      var radio = document.querySelector(selector);
      if (radio) {
        radio.checked = true;
        updateRadioVisualState(radio);
      }
    });
  }

  // Set all cookies to no except required
  function setNecessaryCookiesOnly() {
    var radioGroups = [
      { name: 'input[name="required-cookies"][value="yes"]', value: "yes" },
      { name: 'input[name="marketing-cookies"][value="no"]', value: "no" },
      {
        name: 'input[name="personalisation-cookies"][value="no"]',
        value: "no",
      },
      { name: 'input[name="analytics-cookies"][value="no"]', value: "no" },
    ];

    radioGroups.forEach(function (group) {
      var radio = document.querySelector(group.name);
      if (radio) {
        radio.checked = true;
        updateRadioVisualState(radio);
      }
    });
  }

  // Save preferences and close popup
  function savePreferencesAndClose() {
    var preferences = getCurrentPreferences();
    CookieManager.setCookieConsent(preferences);
    CookieManager.setCookie(
      COOKIES_POPUP_COOKIE_NAME,
      "shown",
      COOKIES_POPUP_EXPIRY_DAYS,
    );
    hideCookiesPopup();

    // Dispatch custom event to notify other popups
    var event = new CustomEvent("cookiesPopupClosed");
    document.dispatchEvent(event);
  }

  // Initialize radio button visual states
  function initializeRadioButtons() {
    var radioGroups = [
      'input[name="required-cookies"]',
      'input[name="marketing-cookies"]',
      'input[name="personalisation-cookies"]',
      'input[name="analytics-cookies"]',
    ];

    radioGroups.forEach(function (groupSelector) {
      var radios = document.querySelectorAll(groupSelector);
      radios.forEach(function (radio) {
        updateRadioVisualState(radio);

        radio.addEventListener("change", function () {
          // Update visual state for all radios in this group
          radios.forEach(function (r) {
            updateRadioVisualState(r);
          });
        });
      });
    });
  }

  // Update visual state of a radio button
  function updateRadioVisualState(radio) {
    var label = radio.closest("label");
    if (!label) return;

    var checkmark = label.querySelector(".rotate-45");
    var textSpan = label.querySelector("span");

    if (radio.checked) {
      if (checkmark) {
        checkmark.classList.remove("opacity-0");
        checkmark.classList.add("opacity-100");
      }
      if (textSpan) {
        textSpan.classList.add("uppercase");
        textSpan.classList.remove("border-b-[0.3px]", "border-black");
      }
    } else {
      if (checkmark) {
        checkmark.classList.remove("opacity-100");
        checkmark.classList.add("opacity-0");
      }
      if (textSpan) {
        textSpan.classList.remove("uppercase");
        textSpan.classList.add("border-b-[0.3px]", "border-black");
      }
    }
  }

  // Show cookies popup if not previously shown
  if (!isCookiesPopupShown()) {
    setTimeout(function () {
      showCookiesPopup();
      // Initialize radio buttons after popup is shown
      setTimeout(function () {
        initializeRadioButtons();
      }, 100);
    }, 2000);
  } else {
    // Initialize radio buttons even if popup won't show
    initializeRadioButtons();
  }

  // event listeners - simple view buttons
  if (acceptButton) {
    acceptButton.addEventListener("click", function () {
      setAllCookiesToYes();
      savePreferencesAndClose();
    });
  }

  if (declineButton) {
    declineButton.addEventListener("click", function () {
      setNecessaryCookiesOnly();
      savePreferencesAndClose();
    });
  }

  if (manageSettingsButton) {
    manageSettingsButton.addEventListener("click", function () {
      showDetailedView();
    });
  }

  if (closeButtonSimple) {
    closeButtonSimple.addEventListener("click", function () {
      savePreferencesAndClose();
    });
  }

  // event listeners - detailed view buttons
  if (allowAllButton) {
    allowAllButton.addEventListener("click", function () {
      setAllCookiesToYes();
      savePreferencesAndClose();
    });
  }

  if (allowNecessaryButton) {
    allowNecessaryButton.addEventListener("click", function () {
      setNecessaryCookiesOnly();
      savePreferencesAndClose();
    });
  }

  if (manageSettingsDetailedButton) {
    manageSettingsDetailedButton.addEventListener("click", function () {
      showSimpleView();
    });
  }

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      savePreferencesAndClose();
    });
  }

  // Close on ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && cookiesPopup.classList.contains("opacity-100")) {
      savePreferencesAndClose();
    }
  });

  // Close on clicking backdrop
  cookiesPopup.addEventListener("click", function (e) {
    if (e.target === cookiesPopup) {
      savePreferencesAndClose();
    }
  });
});

// Fixed Countdown Dismiss
document.addEventListener("DOMContentLoaded", function () {
  var fixedBanner = document.querySelector(".fixed-banner");
  var dismissButton = document.querySelector(".fixed-banner-dismiss");

  if (!fixedBanner) return;

  var COUNTDOWN_COOKIE_NAME = "fixed_countdown_dismissed";
  var COUNTDOWN_EXPIRY_DAYS = 30;

  // Check if countdown was previously dismissed
  function isCountdownDismissed() {
    return CookieManager.isCookieValid(COUNTDOWN_COOKIE_NAME);
  }

  // Show countdown
  function showCountdown() {
    fixedBanner.classList.remove("opacity-0", "pointer-events-none");
    fixedBanner.classList.add("opacity-100", "pointer-events-auto");
  }

  // Hide countdown
  function hideCountdown() {
    fixedBanner.classList.remove("opacity-100", "pointer-events-auto");
    fixedBanner.classList.add("opacity-0", "pointer-events-none");
  }

  // Dismiss countdown and set expiry
  function dismissCountdown() {
    hideCountdown();
    CookieManager.setCookie(
      COUNTDOWN_COOKIE_NAME,
      "dismissed",
      COUNTDOWN_EXPIRY_DAYS,
    );
  }

  // Show countdown if not previously dismissed
  if (!isCountdownDismissed()) {
    showCountdown();
  }

  // Dismiss button event listener
  if (dismissButton) {
    dismissButton.addEventListener("click", function () {
      dismissCountdown();
    });
  }
});

// Unit Conversion for Size Guide
document.addEventListener("DOMContentLoaded", function () {
  // Select all tables with data-conversion attribute
  var sizeGuideTables = document.querySelectorAll("table[data-conversion]");

  if (sizeGuideTables.length === 0) return;

  // Conversion factors
  var INCHES_TO_CM = 2.54;
  var CM_TO_INCHES = 1 / INCHES_TO_CM;

  // Function to detect if a string contains a number (including decimals)
  function containsNumber(str) {
    return /\d+\.?\d*/.test(str);
  }

  // Function to extract number from string
  function extractNumber(str) {
    var match = str.match(/(\d+\.?\d*)/);
    return match ? parseFloat(match[1]) : null;
  }

  // Function to convert inches to cm
  function inchesToCm(inches) {
    return Math.round(inches * INCHES_TO_CM * 10) / 10; // Round to 1 decimal place
  }

  // Function to convert cm to inches
  function cmToInches(cm) {
    return Math.round(cm * CM_TO_INCHES * 10) / 10; // Round to 1 decimal place
  }

  // Function to convert measurement text
  function convertMeasurement(text, fromUnit, toUnit) {
    if (!containsNumber(text)) return text;

    var number = extractNumber(text);
    if (number === null) return text;

    var convertedNumber;
    if (fromUnit === "inches" && toUnit === "cm") {
      convertedNumber = inchesToCm(number);
    } else if (fromUnit === "cm" && toUnit === "inches") {
      convertedNumber = cmToInches(number);
    } else {
      return text; // No conversion needed
    }

    // Replace the number in the original text
    return text.replace(/\d+\.?\d*/, convertedNumber.toString());
  }

  // Function to store original values for a specific table
  function initializeTableMeasurements(table) {
    // Query all td and th elements
    var cells = table.querySelectorAll("td, th");
    cells.forEach(function (cell) {
      var text = cell.textContent.trim();
      if (containsNumber(text)) {
        // Store original value as data attribute
        cell.setAttribute("data-original-value", text);
        cell.setAttribute("data-contains-measurement", "true");
      }
    });
  }

  // Function to convert measurements for a specific table
  function convertTableMeasurements(table, targetUnit) {
    var cells = table.querySelectorAll('[data-contains-measurement="true"]');
    cells.forEach(function (cell) {
      var originalValue = cell.getAttribute("data-original-value");

      // If target unit is inches, show original value (assuming original is in inches)
      if (targetUnit === "inches") {
        cell.textContent = originalValue;
      } else {
        // If target unit is cm, convert from original inches value
        var convertedValue = convertMeasurement(originalValue, "inches", "cm");
        cell.textContent = convertedValue;
      }
    });
  }

  // Initialize each table individually
  sizeGuideTables.forEach(function (table) {
    var tableIndex = table.getAttribute("data-table-index");
    initializeTableMeasurements(table);

    // Find radio buttons for this specific table
    var tableRadios = document.querySelectorAll(
      'input[name="cm-inch-toggle-' + tableIndex + '"]',
    );

    // Add event listeners to this table's radio buttons
    tableRadios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        if (this.checked) {
          var selectedUnit = this.value;
          convertTableMeasurements(table, selectedUnit);
        }
      });
    });
  });

  // Handle visual state for all size guide radio buttons
  var allSizeGuideRadios = document.querySelectorAll(
    'input[name^="cm-inch-toggle-"]',
  );
  allSizeGuideRadios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      // Update visual state for all radios in this specific group
      var groupName = this.name;
      var groupRadios = document.querySelectorAll(
        'input[name="' + groupName + '"]',
      );
      groupRadios.forEach(function (r) {
        updateSizeGuideRadioVisualState(r);
      });
    });

    // Initialize visual state on page load
    updateSizeGuideRadioVisualState(radio);
  });
});

// Update visual state of size guide radio buttons
function updateSizeGuideRadioVisualState(radio) {
  var label = radio.closest("label");
  if (!label) return;

  var checkmark = label.querySelector(".rotate-45");
  var textSpan = label.querySelector("span");

  if (radio.checked) {
    if (checkmark) {
      checkmark.classList.remove("opacity-0");
      checkmark.classList.add("opacity-100");
    }
    if (textSpan) {
      textSpan.classList.remove("border-b-[0.3px]", "border-black");
      textSpan.classList.add("uppercase");
    }
  } else {
    if (checkmark) {
      checkmark.classList.remove("opacity-100");
      checkmark.classList.add("opacity-0");
    }
    if (textSpan) {
      textSpan.classList.remove("uppercase");
      textSpan.classList.add("border-b-[0.3px]", "border-black");
    }
  }
}

// Footer images swiper
document.addEventListener("DOMContentLoaded", function () {
  var footerSwiper = document.querySelector(".footer-images-swiper");

  if (!footerSwiper) return;

  new Swiper(footerSwiper, {
    slidesPerView: 2.3,
    spaceBetween: 16,
    // freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6,
        spaceBetween: 16,
        freeMode: false,
        allowTouchMove: false,
      },
    },
  });
});

// Subnav swiper - unified with desktop
document.addEventListener("DOMContentLoaded", function () {
  var subnavContainer = document.querySelector("[data-subnav-container]");
  if (!subnavContainer) return;

  var subnavItems = subnavContainer.querySelectorAll("[data-subnav-item]");
  if (!subnavItems.length) return;

  var swiperInstance = null;
  var swiperWrapper = null;
  var swiperContainer = null;

  function initSwiper() {
    // Only initialize swiper on mobile (below md breakpoint)
    if (window.innerWidth < 768) {
      if (!swiperInstance) {
        // Wrap items in Swiper markup
        swiperContainer = document.createElement("div");
        swiperContainer.className =
          "swiper subnav-swiper !px-4 overflow-hidden";

        swiperWrapper = document.createElement("div");
        swiperWrapper.className = "swiper-wrapper";

        // Move all items into the wrapper
        subnavItems.forEach(function (item) {
          item.classList.add("swiper-slide");
          item.classList.remove("relative");
          item.removeAttribute("style"); // Remove grid-column-start on mobile
          swiperWrapper.appendChild(item);
        });

        swiperContainer.appendChild(swiperWrapper);
        subnavContainer.appendChild(swiperContainer);

        // Initialize Swiper
        swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: 2.6,
          spaceBetween: 16,
          on: {
            init: function () {
              updateSubnavActiveSlide(this);
            },
            slideChange: function () {
              updateSubnavActiveSlide(this);
            },
          },
        });
      }
    } else if (window.innerWidth >= 768 && swiperInstance) {
      // Destroy swiper and restore desktop layout
      var items = Array.from(subnavItems);

      swiperInstance.destroy(true, true);
      swiperInstance = null;

      // Remove swiper markup and restore items to container
      items.forEach(function (item, index) {
        item.classList.remove("swiper-slide");
        item.classList.add("relative");

        // Restore grid-column-start for first item
        if (index === 0) {
          var startCol = item.getAttribute("data-start-col");
          if (startCol) {
            item.style.gridColumnStart = startCol;
          }
        }

        subnavContainer.appendChild(item);
      });

      // Remove swiper wrapper and container
      if (swiperWrapper && swiperWrapper.parentNode) {
        swiperWrapper.parentNode.removeChild(swiperWrapper);
      }
      if (swiperContainer && swiperContainer.parentNode) {
        swiperContainer.parentNode.removeChild(swiperContainer);
      }

      swiperWrapper = null;
      swiperContainer = null;

      // Reset all styles when switching to desktop
      resetMobileStyles();
    }
  }

  function resetMobileStyles() {
    var allTitles = subnavContainer.querySelectorAll(".subnav-title");
    var allImages = subnavContainer.querySelectorAll(".subnav-mobile-image");

    allTitles.forEach(function (title) {
      title.classList.remove("uppercase", "border-0");
      title.classList.add("border-b-[0.3px]", "border-black");
    });

    allImages.forEach(function (image) {
      image.classList.remove("opacity-100", "grayscale-0");
      image.classList.add("opacity-50", "grayscale");
    });
  }

  function updateSubnavActiveSlide(swiper) {
    // Reset all titles and images
    var allTitles = subnavContainer.querySelectorAll(".subnav-title");
    var allImages = subnavContainer.querySelectorAll(".subnav-mobile-image");

    allTitles.forEach(function (title) {
      title.classList.remove("uppercase", "border-0");
      title.classList.add("border-b-[0.3px]", "border-black");
    });

    allImages.forEach(function (image) {
      image.classList.remove("opacity-100", "grayscale-0");
      image.classList.add("opacity-50", "grayscale");
    });

    // Set active slide
    var activeSlide = swiper.slides[swiper.activeIndex];
    if (activeSlide) {
      var activeTitle = activeSlide.querySelector(".subnav-title");
      var activeImage = activeSlide.querySelector(".subnav-mobile-image");

      if (activeTitle) {
        activeTitle.classList.add("uppercase", "border-0");
        activeTitle.classList.remove("border-b-[0.3px]", "border-black");
      }

      if (activeImage) {
        activeImage.classList.add("opacity-100", "grayscale-0");
        activeImage.classList.remove("opacity-50", "grayscale");
      }
    }
  }

  // Store grid start column in data attribute for restoration
  subnavItems.forEach(function (item, index) {
    if (index === 0 && item.style.gridColumnStart) {
      item.setAttribute("data-start-col", item.style.gridColumnStart);
    }
  });

  // Initialize on load
  initSwiper();

  // Re-initialize on window resize with debounce
  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initSwiper();
    }, 250);
  });
});

// Header images swiper
document.addEventListener("DOMContentLoaded", function () {
  var headerSwiper = document.querySelector(".header-images-swiper");

  if (!headerSwiper) return;

  new Swiper(headerSwiper, {
    slidesPerView: 2.3,
    spaceBetween: 16,
    // freeMode: true,
  });
});

// Mobile Menu Toggle
document.addEventListener("DOMContentLoaded", function () {
  var mobileMenuToggle = document.querySelector("[data-mobile-menu-toggle]");
  var mobileMenuContent = document.querySelector("[data-mobile-menu-content]");
  var mobileMenuInner = document.querySelector("[data-mobile-menu-inner]");
  var mobileHeader = document.querySelector("[data-mobile-header]");
  var mobileLogo = mobileHeader
    ? mobileHeader.querySelector("[data-mobile-logo]")
    : null;

  if (!mobileMenuToggle || !mobileMenuContent || !mobileMenuInner) return;

  var isOpen = false;

  mobileMenuToggle.addEventListener("click", function () {
    if (isOpen) {
      // close: original timing — fade → retract → quick white fade

      mobileMenuInner.classList.remove("opacity-100");
      mobileMenuInner.classList.add("opacity-0");

      setTimeout(function () {
        mobileMenuContent.style.height = "0";
        mobileMenuContent.style.overflowY = "";

        setTimeout(function () {
          if (mobileHeader) {
            mobileHeader.classList.remove("bg-white", "is-mobile-overlay");
          }
        }, 500);
      }, 150);

      mobileMenuToggle.textContent = "Menu";
      mobileMenuToggle.classList.add("uppercase");
      document.body.style.overflow = "";
      isOpen = false;
    } else {
      // close search modal if it's open
      var searchModal = document.querySelector("[data-search-modal]");
      var mobileSearchTrigger = document.querySelector("[data-mobile-search]");
      var header = document.querySelector("header");

      if (searchModal) {
        searchModal.classList.add("opacity-0", "pointer-events-none");
        searchModal.classList.remove("opacity-100", "pointer-events-auto");

        // always reset search trigger text (in case it says "Close")
        if (mobileSearchTrigger) {
          mobileSearchTrigger.textContent = "Search";
          mobileSearchTrigger.classList.remove("uppercase");
        }

        if (header)
          header.classList.remove("backdrop-grayscale", "bg-black/10");

        // reset search input and show only first 4 products
        var searchInput = searchModal.querySelector('input[name="q"]');
        if (searchInput) {
          searchInput.value = "";
        }
        var productItems = searchModal.querySelectorAll(".search-product-item");
        productItems.forEach(function (item, index) {
          if (index < 4) {
            item.classList.remove("hidden");
          } else {
            item.classList.add("hidden");
          }
        });
      }

      // close mini cart if it's open
      var miniCart = document.querySelector("[data-mini-cart]");
      var miniCartOverlay = document.querySelector("[data-mini-cart-overlay]");
      var mobileCartTrigger = document.querySelector("[data-mobile-cart]");

      if (miniCart) {
        miniCart.classList.add("opacity-0", "pointer-events-none");
        miniCart.classList.remove("opacity-100", "pointer-events-auto");

        if (miniCartOverlay) {
          miniCartOverlay.classList.add(
            "opacity-0",
            "pointer-events-none",
            "hidden",
          );
          miniCartOverlay.classList.remove(
            "opacity-100",
            "pointer-events-auto",
          );
        }

        // always reset cart trigger text (in case it says "Close")
        if (mobileCartTrigger) {
          var storedCartCount = "0";
          var cartCountSpan = mobileCartTrigger.querySelector("span");
          if (cartCountSpan) {
            storedCartCount = cartCountSpan.textContent;
          } else {
            // if no span exists (text was "Close"), try to get from mini cart
            var miniCartCount = document.querySelector("[data-cart-count]");
            if (miniCartCount) {
              storedCartCount = miniCartCount.textContent.trim();
            }
          }
          mobileCartTrigger.innerHTML =
            "Cart <span data-mobile-header-cart-count>" +
            storedCartCount +
            "</span>";
          mobileCartTrigger.classList.remove("uppercase");
        }

        if (header)
          header.classList.remove("backdrop-grayscale", "bg-black/10");
      }

      // open menu: fill space between nav and logo; scroll if content needs it
      if (mobileHeader) {
        mobileHeader.classList.add("bg-white", "is-mobile-overlay");
      }
      if (mobileLogo) {
        mobileLogo.style.transition = "none";
        void mobileLogo.offsetHeight;
      }

      var mobileNav = mobileHeader.querySelector("[data-mobile-nav]");
      var viewportH =
        (window.visualViewport && window.visualViewport.height) ||
        window.innerHeight;
      var reserved =
        (mobileNav ? mobileNav.offsetHeight : 0) +
        (mobileLogo ? mobileLogo.offsetHeight : 0);
      var available = Math.max(viewportH - reserved, 0);

      mobileMenuContent.style.height = "auto";
      mobileMenuContent.style.overflowY = "hidden";
      var contentH = mobileMenuInner.scrollHeight;
      mobileMenuContent.style.height = "0px";
      void mobileMenuContent.offsetHeight;

      mobileMenuContent.style.overflowY =
        contentH > available ? "auto" : "hidden";
      mobileMenuContent.style.height = available + "px";

      requestAnimationFrame(function () {
        if (mobileLogo) mobileLogo.style.transition = "";
      });

      setTimeout(function () {
        mobileMenuInner.classList.remove("opacity-0");
        mobileMenuInner.classList.add("opacity-100");
      }, 250);

      mobileMenuToggle.textContent = "Close";
      mobileMenuToggle.classList.remove("uppercase");
      document.body.style.overflow = "hidden";
      isOpen = true;
    }
  });
});

// mobile search and cart triggers - shared scope for cart count
document.addEventListener("DOMContentLoaded", function () {
  var mobileSearchTrigger = document.querySelector("[data-mobile-search]");
  var searchModal = document.querySelector("[data-search-modal]");
  var mobileCartTrigger = document.querySelector("[data-mobile-cart]");
  var miniCart = document.querySelector("[data-mini-cart]");
  var header = document.querySelector("header");
  var menuWrapper = document.querySelector(".menu-wrapper");
  var mobileHeader = document.querySelector("[data-mobile-header]");

  // shared variable to store cart count
  var storedCartCount = "0";

  // initialize stored cart count from dom
  if (mobileCartTrigger) {
    var initialCartCount = mobileCartTrigger.querySelector("span");
    if (initialCartCount) {
      storedCartCount = initialCartCount.textContent;
    }
  }

  // mobile search trigger
  if (mobileSearchTrigger && searchModal) {
    mobileSearchTrigger.addEventListener("click", function (e) {
      e.stopPropagation();
      var isOpen = !searchModal.classList.contains("opacity-0");

      if (isOpen) {
        // close search
        searchModal.classList.add("opacity-0", "pointer-events-none");
        searchModal.classList.remove("opacity-100", "pointer-events-auto");
        mobileSearchTrigger.textContent = "Search";
        mobileSearchTrigger.classList.remove("uppercase");
        if (header)
          header.classList.remove("backdrop-grayscale", "bg-black/10");
        if (mobileHeader) mobileHeader.classList.remove("bg-white");
        document.body.style.overflow = "";

        // reset search input and show only first 4 products
        var searchInput = searchModal.querySelector('input[name="q"]');
        if (searchInput) {
          searchInput.value = "";
        }
        var productItems = searchModal.querySelectorAll(".search-product-item");
        productItems.forEach(function (item, index) {
          if (index < 4) {
            item.classList.remove("hidden");
          } else {
            item.classList.add("hidden");
          }
        });
      } else {
        // close mobile menu if it's open
        var mobileMenuToggle = document.querySelector(
          "[data-mobile-menu-toggle]",
        );
        var mobileMenuContent = document.querySelector(
          "[data-mobile-menu-content]",
        );
        var mobileMenuInner = document.querySelector(
          "[data-mobile-menu-inner]",
        );
        if (
          mobileMenuContent &&
          mobileMenuContent.style.height !== "0" &&
          mobileMenuContent.style.height !== "" &&
          mobileMenuContent.style.height !== "0px"
        ) {
          mobileMenuInner.classList.remove("opacity-100");
          mobileMenuInner.classList.add("opacity-0");
          setTimeout(function () {
            mobileMenuContent.style.height = "0";
            mobileMenuContent.style.overflowY = "";
          }, 150);
          if (mobileMenuToggle) {
            mobileMenuToggle.textContent = "Menu";
            mobileMenuToggle.classList.add("uppercase");
          }
        }

        // close mini cart if it's open
        var miniCartOverlay = document.querySelector(
          "[data-mini-cart-overlay]",
        );
        if (miniCart && !miniCart.classList.contains("opacity-0")) {
          miniCart.classList.add("opacity-0", "pointer-events-none");
          miniCart.classList.remove("opacity-100", "pointer-events-auto");
          if (miniCartOverlay) {
            miniCartOverlay.classList.add(
              "opacity-0",
              "pointer-events-none",
              "hidden",
            );
            miniCartOverlay.classList.remove(
              "opacity-100",
              "pointer-events-auto",
            );
          }
          if (mobileCartTrigger) {
            mobileCartTrigger.innerHTML =
              "Cart <span data-mobile-header-cart-count>" +
              storedCartCount +
              "</span>";
            mobileCartTrigger.classList.remove("uppercase");
          }
        }

        // open search
        searchModal.classList.remove("opacity-0", "pointer-events-none");
        searchModal.classList.add("opacity-100", "pointer-events-auto");
        mobileSearchTrigger.textContent = "Close";
        mobileSearchTrigger.classList.remove("uppercase");
        if (header) header.classList.add("backdrop-grayscale", "bg-black/10");
        if (mobileHeader) mobileHeader.classList.add("bg-white");
        document.body.style.overflow = "hidden";

        // focus on search input
        var searchInput = searchModal.querySelector('input[type="text"]');
        if (searchInput) {
          setTimeout(function () {
            searchInput.focus();
          }, 100);
        }
      }
    });
  }

  // mobile cart trigger
  if (mobileCartTrigger && miniCart) {
    var miniCartOverlay = document.querySelector("[data-mini-cart-overlay]");

    mobileCartTrigger.addEventListener("click", function (e) {
      e.stopPropagation();
      var isOpen = !miniCart.classList.contains("opacity-0");

      if (isOpen) {
        // close cart
        miniCart.classList.add("opacity-0", "pointer-events-none");
        miniCart.classList.remove("opacity-100", "pointer-events-auto");
        if (miniCartOverlay) {
          miniCartOverlay.classList.add(
            "opacity-0",
            "pointer-events-none",
            "hidden",
          );
          miniCartOverlay.classList.remove(
            "opacity-100",
            "pointer-events-auto",
          );
        }
        mobileCartTrigger.innerHTML =
          "Cart <span data-mobile-header-cart-count>" +
          storedCartCount +
          "</span>";
        mobileCartTrigger.classList.remove("uppercase");
        if (mobileHeader) mobileHeader.classList.remove("bg-white");

        // only remove header grayscale if search is not open
        var isSearchOpen =
          searchModal && !searchModal.classList.contains("opacity-0");
        if (!isSearchOpen) {
          if (header)
            header.classList.remove("backdrop-grayscale", "bg-black/10");
        }

        document.body.style.overflow = "";
      } else {
        // store current cart count before changing text
        var cartCountSpan = mobileCartTrigger.querySelector("span");
        if (cartCountSpan) {
          storedCartCount = cartCountSpan.textContent;
        }

        // close mobile menu if it's open
        var mobileMenuToggle = document.querySelector(
          "[data-mobile-menu-toggle]",
        );
        var mobileMenuContent = document.querySelector(
          "[data-mobile-menu-content]",
        );
        var mobileMenuInner = document.querySelector(
          "[data-mobile-menu-inner]",
        );
        if (
          mobileMenuContent &&
          mobileMenuContent.style.height !== "0" &&
          mobileMenuContent.style.height !== "" &&
          mobileMenuContent.style.height !== "0px"
        ) {
          mobileMenuInner.classList.remove("opacity-100");
          mobileMenuInner.classList.add("opacity-0");
          setTimeout(function () {
            mobileMenuContent.style.height = "0";
            mobileMenuContent.style.overflowY = "";
          }, 150);
          if (mobileMenuToggle) {
            mobileMenuToggle.textContent = "Menu";
            mobileMenuToggle.classList.add("uppercase");
          }
        }

        // close search modal if it's open
        if (searchModal && !searchModal.classList.contains("opacity-0")) {
          searchModal.classList.add("opacity-0", "pointer-events-none");
          searchModal.classList.remove("opacity-100", "pointer-events-auto");
          if (mobileSearchTrigger) mobileSearchTrigger.textContent = "Search";

          // reset search input and show only first 4 products
          var searchInput = searchModal.querySelector('input[name="q"]');
          if (searchInput) {
            searchInput.value = "";
          }
          var productItems = searchModal.querySelectorAll(
            ".search-product-item",
          );
          productItems.forEach(function (item, index) {
            if (index < 4) {
              item.classList.remove("hidden");
            } else {
              item.classList.add("hidden");
            }
          });
        }

        // open cart
        miniCart.classList.remove("opacity-0", "pointer-events-none");
        miniCart.classList.add("opacity-100", "pointer-events-auto");
        if (miniCartOverlay) {
          miniCartOverlay.classList.remove(
            "opacity-0",
            "pointer-events-none",
            "hidden",
          );
          miniCartOverlay.classList.add("opacity-100", "pointer-events-auto");
        }
        mobileCartTrigger.textContent = "Close";
        mobileCartTrigger.classList.remove("uppercase");
        if (mobileHeader) mobileHeader.classList.add("bg-white");
        document.body.style.overflow = "hidden";
      }
    });
  }
});

// products block swiper - mobile only
document.addEventListener("DOMContentLoaded", function () {
  var container = document.querySelector(".products-grid-container");
  var wrapper = document.querySelector(".products-grid-wrapper");
  var items = document.querySelectorAll(".products-grid-wrapper .product-item");

  if (!container || !wrapper || !items.length) return;

  window.productsSwiperInstance = null;

  function initProductsSwiper() {
    // init swiper on mobile only
    if (window.innerWidth < 768) {
      if (!window.productsSwiperInstance) {
        // add swiper classes
        container.classList.add("swiper");
        wrapper.classList.remove("grid", "grid-cols-8", "gap-4");
        wrapper.classList.add("swiper-wrapper");
        items.forEach(function (item) {
          item.classList.add("swiper-slide");
        });

        window.productsSwiperInstance = new Swiper(container, {
          slidesPerView: 2.3,
          spaceBetween: 16,
        });
      }
    } else if (window.productsSwiperInstance) {
      // destroy swiper on desktop
      window.productsSwiperInstance.destroy(true, true);
      window.productsSwiperInstance = null;

      // remove swiper classes and restore grid
      container.classList.remove("swiper");
      wrapper.classList.remove("swiper-wrapper");
      wrapper.classList.add("grid", "grid-cols-8", "gap-4");
      items.forEach(function (item) {
        item.classList.remove("swiper-slide");
      });
    }
  }

  initProductsSwiper();

  // reinit on resize
  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initProductsSwiper();
    }, 250);
  });
});

// split-width swiper - mobile only
document.addEventListener("DOMContentLoaded", function () {
  var containers = document.querySelectorAll(".split-width-container");

  if (!containers.length) return;

  containers.forEach(function (container) {
    var splitWidthSwiper = null;

    function initOrDestroySplitWidthSwiper() {
      var isMobile = window.innerWidth < 768;

      if (isMobile && !splitWidthSwiper) {
        // mobile: init swiper
        container.classList.add("swiper");
        var children = Array.from(container.children);

        var wrapper = document.createElement("div");
        wrapper.className = "swiper-wrapper";

        children.forEach(function (child) {
          child.classList.add("swiper-slide");
          wrapper.appendChild(child);
        });

        container.appendChild(wrapper);

        splitWidthSwiper = new Swiper(container, {
          slidesPerView: 1.2,
          // spaceBetween: 16,
        });
      } else if (!isMobile && splitWidthSwiper) {
        // desktop: destroy swiper
        splitWidthSwiper.destroy(true, true);
        splitWidthSwiper = null;

        container.classList.remove("swiper");
        var wrapper = container.querySelector(".swiper-wrapper");
        if (wrapper) {
          var slides = Array.from(wrapper.children);
          slides.forEach(function (slide) {
            slide.classList.remove("swiper-slide", "swiper-slide-active");
            container.appendChild(slide);
          });
          wrapper.remove();
        }
      }
    }

    initOrDestroySplitWidthSwiper();

    var resizeTimeout;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(initOrDestroySplitWidthSwiper, 250);
    });
  });
});

// editorial block swiper - mobile only
document.addEventListener("DOMContentLoaded", function () {
  var sections = document.querySelectorAll(".editorial-block");

  if (!sections.length) return;

  sections.forEach(function (section) {
    var sliderMobile = section.getAttribute("data-slider-mobile") === "true";

    if (!sliderMobile) return;

    var container = section.querySelector(".editorial-block-container");
    var items = section.querySelectorAll(".editorial-block-item");
    var editorialSwiper = null;

    // store original classes to restore later
    var originalContainerClasses = container.className;
    var originalItemClasses = Array.from(items).map(function (item) {
      return item.className;
    });

    function initOrDestroyEditorialSwiper() {
      var isMobile = window.innerWidth < 768;

      if (isMobile && !editorialSwiper) {
        // mobile: init swiper
        container.classList.add("swiper", "!overflow-visible", "!px-4");
        container.classList.remove(
          "grid",
          "grid-cols-8",
          "gap-x-4",
          "p-4",
          "gap-y-4",
        );

        // create swiper wrapper
        var wrapper = document.createElement("div");
        wrapper.className = "swiper-wrapper";

        items.forEach(function (item) {
          item.classList.add("swiper-slide");
          wrapper.appendChild(item);
        });

        container.appendChild(wrapper);

        editorialSwiper = new Swiper(container, {
          slidesPerView: 1.1,
          spaceBetween: 16,
        });
      } else if (!isMobile && editorialSwiper) {
        // desktop: destroy swiper and restore original state
        editorialSwiper.destroy(true, true);
        editorialSwiper = null;

        // remove swiper wrapper and restore items to container
        var wrapper = container.querySelector(".swiper-wrapper");
        if (wrapper) {
          Array.from(wrapper.children).forEach(function (item) {
            container.appendChild(item);
          });
          wrapper.remove();
        }

        // restore original classes
        container.className = originalContainerClasses;
        items.forEach(function (item, index) {
          item.className = originalItemClasses[index];
        });
      }
    }

    initOrDestroyEditorialSwiper();

    var resizeTimeout;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(initOrDestroyEditorialSwiper, 250);
    });
  });
});

// video controls - pause and unmute
document.addEventListener("DOMContentLoaded", function () {
  var pauseButtons = document.querySelectorAll("[data-video-pause]");
  var unmuteButtons = document.querySelectorAll("[data-video-unmute]");

  // handle pause/play button
  pauseButtons.forEach(function (pauseBtn) {
    pauseBtn.addEventListener("click", function () {
      // find the video element (it's a sibling or parent's sibling of the controls)
      var videoControls = this.closest(".video-controls");
      if (!videoControls) return;

      var videoContainer = videoControls.parentElement;
      var video = videoContainer.querySelector("video");

      if (!video) return;

      if (video.paused) {
        video.play();
        this.textContent = "Pause";
      } else {
        video.pause();
        this.textContent = "Play";
      }
    });
  });

  // handle unmute/mute button
  unmuteButtons.forEach(function (unmuteBtn) {
    unmuteBtn.addEventListener("click", function () {
      // find the video element (it's a sibling or parent's sibling of the controls)
      var videoControls = this.closest(".video-controls");
      if (!videoControls) return;

      var videoContainer = videoControls.parentElement;
      var video = videoContainer.querySelector("video");

      if (!video) return;

      if (video.muted) {
        video.muted = false;
        this.textContent = "Mute";
      } else {
        video.muted = true;
        this.textContent = "Unmute";
      }
    });
  });
});
